import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** An RFC-3339 compliant Full Date Scalar */
  Date: any;
  /** An RFC-3339 compliant DateTime Scalar */
  DateTime: any;
  /** A signed decimal number, which supports arbitrary precision and is serialized as a string. Example value: "29.99". */
  Decimal: any;
  /** A custom scalar that handles LocalTime values */
  Time: any;
  /** A custom scalar that handles UUID values */
  UUID: any;
};

export type AddGameInput = {
  readonly enteringTeamId: Scalars['Int'];
  readonly opponentTeamId: Scalars['Int'];
  readonly data: GameSchedulingFormInput;
  readonly approvers?: Maybe<ReadonlyArray<GameFormApprovalInput>>;
};

export type AuthResponse = SuccessfulAuthResponse | FailedAuthResponse;

export type CancelledGameInfo = {
  readonly __typename?: 'CancelledGameInfo';
  readonly cancelReason?: Maybe<Scalars['String']>;
  readonly rescheduledGame?: Maybe<Game>;
};

export type CreateAccountData = {
  readonly email: Scalars['String'];
  readonly password: Scalars['String'];
};

export type CreateAccountResponse = SuccessfulCreateAccountResponse | FailedCreateAccountResponse;

export type CreateGameChangeRequestInput = {
  readonly date?: Maybe<Scalars['Date']>;
  readonly time?: Maybe<Scalars['Time']>;
  readonly fieldId?: Maybe<Scalars['Int']>;
};

export type CreateGameInput = {
  readonly opponentTeamId: Scalars['Int'];
  readonly date: Scalars['Date'];
  readonly time: Scalars['Time'];
  readonly fieldId: Scalars['Int'];
  readonly enteringTeamIsHomeTeam?: Scalars['Boolean'];
};

export type CreateOrderInput = {
  readonly teamId: Scalars['Int'];
  readonly productId: Scalars['Int'];
  readonly quantity: Scalars['Int'];
};

export type CreateOrderPayload = {
  readonly __typename?: 'CreateOrderPayload';
  readonly success: Scalars['Boolean'];
  readonly order?: Maybe<Order>;
};

export type CreateRawGameInput = {
  readonly opponentTeam: Scalars['Int'];
  readonly date: Scalars['Date'];
  readonly time: Scalars['Time'];
  readonly field: Scalars['Int'];
  readonly isHomeGame: Scalars['Boolean'];
};

export enum CurrencyCode {
  Usd = 'USD'
}




export type DivisionModifier = {
  readonly __typename?: 'DivisionModifier';
  readonly id: Scalars['Int'];
  readonly name: Scalars['String'];
  readonly rank: Scalars['Int'];
};

export type FailedAuthResponse = {
  readonly __typename?: 'FailedAuthResponse';
  readonly message: Scalars['String'];
};

export type FailedCreateAccountResponse = {
  readonly __typename?: 'FailedCreateAccountResponse';
  readonly message: Scalars['String'];
};

export type Field = {
  readonly __typename?: 'Field';
  readonly id: Scalars['Int'];
  readonly name: Scalars['String'];
};

export type Game = {
  readonly __typename?: 'Game';
  readonly id: Scalars['Int'];
  readonly homeTeam: Team;
  readonly awayTeam: Team;
  readonly date?: Maybe<Scalars['Date']>;
  readonly time?: Maybe<Scalars['Time']>;
  readonly dateTime?: Maybe<Scalars['DateTime']>;
  readonly score?: Maybe<GameScore>;
  readonly field?: Maybe<Field>;
  readonly primaryUmpire?: Maybe<Umpire>;
  readonly secondaryUmpire?: Maybe<Umpire>;
  readonly details: GameDetails;
  readonly isCancelled: Scalars['Boolean'];
  readonly isFlagged: Scalars['Boolean'];
  readonly notes: Scalars['String'];
};

export type GameCancellationForm = GameForm & {
  readonly __typename?: 'GameCancellationForm';
  readonly id: Scalars['Int'];
  readonly timeCreated: Scalars['DateTime'];
  readonly createdBy?: Maybe<Team>;
  readonly approvalStatus: GameFormApprovalStatus;
  readonly approvers: ReadonlyArray<GameFormApprover>;
};

export type GameChangeRequest = {
  readonly __typename?: 'GameChangeRequest';
  readonly id: Scalars['ID'];
  readonly creationTime: Scalars['DateTime'];
  readonly syncToken: Scalars['String'];
  readonly game: GameV2;
  readonly team: Team;
  readonly date?: Maybe<Scalars['Date']>;
  readonly time?: Maybe<Scalars['Time']>;
  readonly field?: Maybe<Field>;
  readonly homeTeamId?: Maybe<Scalars['Int']>;
};

export type GameDetails = {
  readonly __typename?: 'GameDetails';
  readonly homeTeamRecord: Scalars['String'];
  readonly awayTeamRecord: Scalars['String'];
};

export type GameForm = {
  readonly id: Scalars['Int'];
  readonly timeCreated: Scalars['DateTime'];
  /**  Null means admin submitted form */
  readonly createdBy?: Maybe<Team>;
  readonly approvalStatus: GameFormApprovalStatus;
  readonly approvers: ReadonlyArray<GameFormApprover>;
};

export type GameFormApprovalInput = {
  readonly teamId: Scalars['Int'];
};

export enum GameFormApprovalStatus {
  Pending = 'PENDING',
  Approved = 'APPROVED',
  Declined = 'DECLINED',
  Closed = 'CLOSED'
}

export type GameFormApprover = {
  readonly __typename?: 'GameFormApprover';
  readonly team: Team;
  readonly status: GameFormApprovalStatus;
  readonly statusLastUpdated: Scalars['DateTime'];
};

export type GameSchedulingDetails = {
  readonly __typename?: 'GameSchedulingDetails';
  readonly homeTeam: Team;
  readonly awayTeam: Team;
  readonly field: Field;
  readonly dateTime: Scalars['DateTime'];
};

export type GameSchedulingForm = GameForm & {
  readonly __typename?: 'GameSchedulingForm';
  readonly id: Scalars['Int'];
  readonly timeCreated: Scalars['DateTime'];
  readonly createdBy?: Maybe<Team>;
  readonly approvalStatus: GameFormApprovalStatus;
  readonly approvers: ReadonlyArray<GameFormApprover>;
  readonly gameDateTime: Scalars['DateTime'];
  readonly gameField: Field;
  readonly isHomeGameForEnteringTeam: Scalars['Boolean'];
};

export type GameSchedulingFormInput = {
  readonly date: Scalars['Date'];
  readonly time: Scalars['Time'];
  readonly fieldId: Scalars['Int'];
  readonly enteringTeamIsHomeTeam?: Scalars['Boolean'];
};

export type GameScore = {
  readonly __typename?: 'GameScore';
  readonly homeTeamRuns: Scalars['Int'];
  readonly awayTeamRuns: Scalars['Int'];
};

export type GameScoreReportForm = GameForm & {
  readonly __typename?: 'GameScoreReportForm';
  readonly id: Scalars['Int'];
  readonly timeCreated: Scalars['DateTime'];
  readonly createdBy?: Maybe<Team>;
  readonly approvalStatus: GameFormApprovalStatus;
  readonly approvers: ReadonlyArray<GameFormApprover>;
};

export type GameUmpireAssignmentForm = GameForm & {
  readonly __typename?: 'GameUmpireAssignmentForm';
  readonly id: Scalars['Int'];
  readonly timeCreated: Scalars['DateTime'];
  readonly createdBy?: Maybe<Team>;
  readonly approvalStatus: GameFormApprovalStatus;
  readonly approvers: ReadonlyArray<GameFormApprover>;
};

export type GameUpdates = {
  readonly __typename?: 'GameUpdates';
  readonly setDate?: Maybe<Game>;
  readonly setTime?: Maybe<Game>;
  readonly setField?: Maybe<Game>;
  readonly setHomeTeam?: Maybe<Game>;
  readonly setAwayTeam?: Maybe<Game>;
  readonly setHomeTeamRuns?: Maybe<Game>;
  readonly setAwayTeamRuns?: Maybe<Game>;
  readonly setPrimaryUmpire?: Maybe<Game>;
  readonly setSecondaryUmpire?: Maybe<Game>;
  readonly setCancelledStatus?: Maybe<Game>;
  readonly setFlaggedStatus?: Maybe<Game>;
  readonly setNotes?: Maybe<Game>;
  readonly deleteGame?: Maybe<Scalars['Int']>;
};


export type GameUpdatesSetDateArgs = {
  date: Scalars['Date'];
};


export type GameUpdatesSetTimeArgs = {
  time: Scalars['Time'];
};


export type GameUpdatesSetFieldArgs = {
  fieldId: Scalars['Int'];
};


export type GameUpdatesSetHomeTeamArgs = {
  teamId: Scalars['Int'];
};


export type GameUpdatesSetAwayTeamArgs = {
  teamId: Scalars['Int'];
};


export type GameUpdatesSetHomeTeamRunsArgs = {
  runs: Scalars['Int'];
};


export type GameUpdatesSetAwayTeamRunsArgs = {
  runs: Scalars['Int'];
};


export type GameUpdatesSetPrimaryUmpireArgs = {
  umpireId?: Maybe<Scalars['Int']>;
};


export type GameUpdatesSetSecondaryUmpireArgs = {
  umpireId?: Maybe<Scalars['Int']>;
};


export type GameUpdatesSetCancelledStatusArgs = {
  status: Scalars['Boolean'];
};


export type GameUpdatesSetFlaggedStatusArgs = {
  status: Scalars['Boolean'];
};


export type GameUpdatesSetNotesArgs = {
  notes: Scalars['String'];
};

export type GameV2 = {
  readonly __typename?: 'GameV2';
  readonly id: Scalars['ID'];
  readonly syncToken: Scalars['String'];
  readonly createdBy: Team;
  readonly homeTeam: Team;
  readonly awayTeam: Team;
  readonly field: Field;
  readonly date: Scalars['Date'];
  readonly time: Scalars['Time'];
  readonly dateTime: Scalars['DateTime'];
  readonly isConfirmed?: Maybe<Scalars['Boolean']>;
  readonly changeRequest?: Maybe<GameChangeRequest>;
  readonly cancelStatus?: Maybe<CancelledGameInfo>;
};

export type GameV3 = {
  readonly __typename?: 'GameV3';
  readonly id: Scalars['Int'];
  readonly createdBy: Team;
  readonly opponent: Team;
  /**  Non null if there is an approved scheduling form */
  readonly schedulingDetails?: Maybe<GameSchedulingDetails>;
  readonly mostRecentSchedulingDetails?: Maybe<GameSchedulingDetails>;
  readonly gameSchedulingForms: ReadonlyArray<GameSchedulingForm>;
  readonly formHistory: ReadonlyArray<GameForm>;
  readonly score?: Maybe<GameScore>;
  readonly details: GameDetails;
  readonly primaryUmpire?: Maybe<Umpire>;
  readonly secondaryUmpire?: Maybe<Umpire>;
  readonly notes?: Maybe<Scalars['String']>;
  readonly isFlagged: Scalars['Boolean'];
  readonly isLocked: Scalars['Boolean'];
  readonly wasLockedThenUnlocked: Scalars['Boolean'];
  readonly syncToken: Scalars['String'];
  readonly isCancelled: Scalars['Boolean'];
};

/**
 * type TeamV2 {
 *     id: ID!
 * 
 *     name: String!
 *     avatar: String
 * 
 *     division: LeagueDivision!
 * 
 *     members: TeamMemberConnection!
 * }
 * 
 * type SiteUser {
 *     id: ID!
 * 
 *     email: String!
 *     phoneNumber: String
 * 
 *     firstName: String!
 *     lastName: String!
 * 
 *     organizations: [AthleticOrganization!]!
 * 
 *     teams: TeamConnection!
 *     activeTeams: TeamConnection!
 * }
 * 
 * interface Member {
 *     id: ID!
 * 
 *     firstName: String!
 *     lastName: String!
 * }
 * 
 * type TeamMember implements Member {
 *     id: ID!
 * 
 *     firstName: String!
 *     lastName: String!
 * 
 *     email: String!
 *     phoneNumber: String
 * }
 * 
 * type TeamMemberConnection {
 *     edges: [TeamMemberEdge!]
 *     pageInfo: PageInfo!
 * }
 * 
 * type TeamMemberEdge {
 *     cursor: String!
 *     node: TeamMember!
 *     role: TeamMemberRole!
 * }
 * 
 * enum TeamMemberRole {
 *     HEAD_COACH
 *     ASSISTANT_COACH
 *     SCHEDULER
 *     MANAGER
 *     PLAYER
 * }
 * 
 * type AthleticOrganization {
 *     id: ID!
 * 
 *     name: String!
 * 
 *     members: AthleticOrganizationMemberConnection!
 * 
 *     teams: TeamConnection!
 *     activeTeams: TeamConnection!
 * }
 * 
 * type AthleticOrganizationMember implements Member {
 *     id: ID!
 * 
 *     firstName: String!
 *     lastName: String!
 * 
 *     email: String!
 *     phoneNumber: String
 * }
 * 
 * type AthleticOrganizationMemberConnection {
 *     edges: [AthleticOrganizationMemberEdge!]
 *     pageInfo: PageInfo!
 * }
 * 
 * type AthleticOrganizationMemberEdge {
 *     cursor: String!
 *     node: AthleticOrganizationMember!
 * }
 */
export type Jkdsfkljsdf = {
  readonly __typename?: 'JKDSFKLJSDF';
  readonly _?: Maybe<Scalars['Boolean']>;
};

export type League = {
  readonly __typename?: 'League';
  readonly id: Scalars['Int'];
  readonly name: Scalars['String'];
  readonly currencyCode: CurrencyCode;
  readonly seasons: ReadonlyArray<LeagueSeason>;
  readonly seasonsOpenForRegistration: ReadonlyArray<LeagueSeason>;
};

export type LeagueDivision = {
  readonly __typename?: 'LeagueDivision';
  readonly id: Scalars['Int'];
  readonly name: Scalars['String'];
  readonly rank: Scalars['Int'];
  readonly group: TeamGroup;
  readonly modifier?: Maybe<DivisionModifier>;
  readonly season: LeagueSeason;
};

export type LeagueSeason = {
  readonly __typename?: 'LeagueSeason';
  readonly id: Scalars['Int'];
  readonly name: Scalars['String'];
  readonly isOpenForRegistration: Scalars['Boolean'];
  readonly divisions: ReadonlyArray<LeagueDivision>;
  readonly league: League;
  readonly teams: ReadonlyArray<Team>;
};

export type Location = {
  readonly __typename?: 'Location';
  readonly latitude: Scalars['String'];
  readonly longitude: Scalars['String'];
};

export type Money = {
  readonly __typename?: 'Money';
  readonly currencyCode: CurrencyCode;
  readonly amount: Scalars['Decimal'];
};

export type Mutation = {
  readonly __typename?: 'Mutation';
  readonly reportVisit?: Maybe<Scalars['Boolean']>;
  readonly registerTeam?: Maybe<Team>;
  readonly updateTeam: TeamUpdates;
  readonly updateRequirements: RequirementUpdates;
  readonly reportGameScore?: Maybe<Game>;
  readonly reportGameScoreNew?: Maybe<GameV3>;
  readonly reportGameScoreAdmin?: Maybe<Game>;
  readonly updateGame: GameUpdates;
  /**  createGame(data: CreateGameInput!): Game */
  readonly setPortalHomeContent?: Maybe<Scalars['Boolean']>;
  readonly sendPortalLinks?: Maybe<Scalars['Boolean']>;
  readonly assignPrimaryUmpireToGame?: Maybe<GameV3>;
  readonly assignSecondaryUmpireToGame?: Maybe<GameV3>;
  readonly setNotesForGame?: Maybe<GameV3>;
  readonly setFlaggedStatus?: Maybe<GameV3>;
  readonly removeGame?: Maybe<GameV3>;
  readonly cancelGame?: Maybe<GameV3>;
  readonly uncancelGame?: Maybe<GameV3>;
  readonly setTableInteractionStatus?: Maybe<TableInteractionEvent>;
  readonly removeTableInteractionStatusForClient?: Maybe<Scalars['Boolean']>;
  readonly createRawGame: RawGame;
  readonly updateRawGame: RawGameUpdates;
  readonly createAccount: CreateAccountResponse;
  readonly authenticate: AuthResponse;
  readonly logout: Scalars['Boolean'];
  readonly requestPasswordReset?: Maybe<Scalars['Boolean']>;
  readonly resetPassword?: Maybe<Scalars['Boolean']>;
  readonly verifyEmailAddress: Scalars['Boolean'];
  readonly updateUserFirstName: PortalUser;
  readonly updateUserLastName: PortalUser;
  readonly updateUserUsername: PortalUser;
  readonly addGame?: Maybe<GameV3>;
  readonly updateFormApprovalStatusForTeam?: Maybe<GameV3>;
  readonly createGameSchedulingChangeRequest?: Maybe<GameV3>;
  readonly setGameLockedStatus?: Maybe<GameV3>;
  readonly createGame?: Maybe<GameV2>;
  readonly updateGameDate?: Maybe<GameV2>;
  readonly updateGameTime?: Maybe<GameV2>;
  readonly updateGameField?: Maybe<GameV2>;
  readonly updateGameHomeTeam?: Maybe<GameV2>;
  readonly deleteGame?: Maybe<GameV2>;
  readonly confirmGame?: Maybe<GameV2>;
  readonly rejectGame?: Maybe<GameV2>;
  readonly createGameChangeRequest?: Maybe<GameChangeRequest>;
  readonly updateGameChangeRequestDate?: Maybe<GameChangeRequest>;
  readonly updateGameChangeRequestTime?: Maybe<GameChangeRequest>;
  readonly updateGameChangeRequestField?: Maybe<GameChangeRequest>;
  readonly updateGameChangeRequestHomeTeam?: Maybe<GameChangeRequest>;
  readonly cancelGameChangeRequest?: Maybe<GameChangeRequest>;
  readonly acceptGameChangeRequest?: Maybe<GameChangeRequest>;
  readonly rejectGameChangeRequest?: Maybe<GameChangeRequest>;
  readonly rescheduleGame?: Maybe<GameV2>;
  readonly createOrder: CreateOrderPayload;
  readonly updateOrderPaymentStatus: UpdateOrderPaymentStatusPayload;
  readonly updateOrderFulfilmentStatus?: Maybe<Order>;
  readonly updateOrderQuantity?: Maybe<Order>;
  readonly createCheckoutSessionForOrderIds?: Maybe<Scalars['String']>;
};


export type MutationReportVisitArgs = {
  fingerprint: Scalars['String'];
  path?: Maybe<Scalars['String']>;
  search?: Maybe<Scalars['String']>;
};


export type MutationRegisterTeamArgs = {
  teamData?: Maybe<RegisterTeamInput>;
};


export type MutationReportGameScoreArgs = {
  gameId: Scalars['Int'];
  enteringTeamId: Scalars['Int'];
  homeTeamRuns: Scalars['Int'];
  awayTeamRuns: Scalars['Int'];
};


export type MutationReportGameScoreNewArgs = {
  gameId: Scalars['Int'];
  data: ReportGameScoreInput;
};


export type MutationReportGameScoreAdminArgs = {
  gameId: Scalars['Int'];
  homeTeamRuns: Scalars['Int'];
  awayTeamRuns: Scalars['Int'];
};


export type MutationUpdateGameArgs = {
  id: Scalars['Int'];
};


export type MutationSetPortalHomeContentArgs = {
  content?: Maybe<Scalars['String']>;
};


export type MutationSendPortalLinksArgs = {
  email: Scalars['String'];
};


export type MutationAssignPrimaryUmpireToGameArgs = {
  gameId: Scalars['Int'];
  umpireId?: Maybe<Scalars['Int']>;
};


export type MutationAssignSecondaryUmpireToGameArgs = {
  gameId: Scalars['Int'];
  umpireId?: Maybe<Scalars['Int']>;
};


export type MutationSetNotesForGameArgs = {
  gameId: Scalars['Int'];
  notes?: Maybe<Scalars['String']>;
};


export type MutationSetFlaggedStatusArgs = {
  gameId: Scalars['Int'];
  status: Scalars['Boolean'];
};


export type MutationRemoveGameArgs = {
  gameId: Scalars['Int'];
};


export type MutationCancelGameArgs = {
  gameId: Scalars['Int'];
  cancellationReason?: Maybe<Scalars['String']>;
};


export type MutationUncancelGameArgs = {
  gameId: Scalars['Int'];
};


export type MutationSetTableInteractionStatusArgs = {
  data: Scalars['String'];
};


export type MutationCreateRawGameArgs = {
  enteringTeamId: Scalars['Int'];
  data: CreateRawGameInput;
};


export type MutationCreateAccountArgs = {
  input: CreateAccountData;
};


export type MutationAuthenticateArgs = {
  username: Scalars['String'];
  password: Scalars['String'];
};


export type MutationRequestPasswordResetArgs = {
  email: Scalars['String'];
};


export type MutationResetPasswordArgs = {
  token: Scalars['String'];
  password: Scalars['String'];
};


export type MutationVerifyEmailAddressArgs = {
  verificationText: Scalars['String'];
};


export type MutationUpdateUserFirstNameArgs = {
  id: Scalars['UUID'];
  firstName: Scalars['String'];
};


export type MutationUpdateUserLastNameArgs = {
  id: Scalars['UUID'];
  lastName: Scalars['String'];
};


export type MutationUpdateUserUsernameArgs = {
  id: Scalars['UUID'];
  username: Scalars['String'];
};


export type MutationAddGameArgs = {
  data: AddGameInput;
};


export type MutationUpdateFormApprovalStatusForTeamArgs = {
  formId: Scalars['Int'];
  status: Scalars['String'];
};


export type MutationCreateGameSchedulingChangeRequestArgs = {
  gameId: Scalars['Int'];
  data: GameSchedulingFormInput;
  approvers?: Maybe<ReadonlyArray<GameFormApprovalInput>>;
};


export type MutationSetGameLockedStatusArgs = {
  gameId: Scalars['Int'];
  status: Scalars['Boolean'];
  syncToken: Scalars['String'];
};


export type MutationCreateGameArgs = {
  data: CreateGameInput;
};


export type MutationUpdateGameDateArgs = {
  gameId: Scalars['Int'];
  date: Scalars['Date'];
};


export type MutationUpdateGameTimeArgs = {
  gameId: Scalars['Int'];
  time: Scalars['Time'];
};


export type MutationUpdateGameFieldArgs = {
  gameId: Scalars['Int'];
  fieldId: Scalars['Int'];
};


export type MutationUpdateGameHomeTeamArgs = {
  gameId: Scalars['Int'];
  homeTeam: Scalars['Int'];
};


export type MutationDeleteGameArgs = {
  gameId: Scalars['Int'];
};


export type MutationConfirmGameArgs = {
  gameId: Scalars['Int'];
  syncToken: Scalars['String'];
};


export type MutationRejectGameArgs = {
  gameId: Scalars['Int'];
  syncToken: Scalars['String'];
};


export type MutationCreateGameChangeRequestArgs = {
  gameId: Scalars['Int'];
  data: CreateGameChangeRequestInput;
};


export type MutationUpdateGameChangeRequestDateArgs = {
  requestId: Scalars['Int'];
  date: Scalars['Date'];
};


export type MutationUpdateGameChangeRequestTimeArgs = {
  requestId: Scalars['Int'];
  time: Scalars['Time'];
};


export type MutationUpdateGameChangeRequestFieldArgs = {
  requestId: Scalars['Int'];
  fieldId: Scalars['Int'];
};


export type MutationUpdateGameChangeRequestHomeTeamArgs = {
  requestId: Scalars['Int'];
  homeTeam: Scalars['Int'];
};


export type MutationCancelGameChangeRequestArgs = {
  requestId: Scalars['Int'];
};


export type MutationAcceptGameChangeRequestArgs = {
  requestId: Scalars['Int'];
  syncToken: Scalars['String'];
};


export type MutationRejectGameChangeRequestArgs = {
  requestId: Scalars['Int'];
  syncToken: Scalars['String'];
  comment?: Maybe<Scalars['String']>;
};


export type MutationRescheduleGameArgs = {
  gameId: Scalars['Int'];
  data: RescheduleGameInput;
};


export type MutationCreateOrderArgs = {
  input: CreateOrderInput;
};


export type MutationUpdateOrderPaymentStatusArgs = {
  orderId: Scalars['Int'];
  paymentStatus: Scalars['Boolean'];
  paymentNotes?: Maybe<Scalars['String']>;
};


export type MutationUpdateOrderFulfilmentStatusArgs = {
  orderId: Scalars['Int'];
  status: Scalars['Boolean'];
};


export type MutationUpdateOrderQuantityArgs = {
  orderId: Scalars['Int'];
  quantity: Scalars['Int'];
};


export type MutationCreateCheckoutSessionForOrderIdsArgs = {
  orderIds: ReadonlyArray<Scalars['Int']>;
};

export type Order = {
  readonly __typename?: 'Order';
  readonly id: Scalars['Int'];
  readonly productDetails: ProductDetails;
  readonly quantity: Scalars['Int'];
  readonly didReceivePayment: Scalars['Boolean'];
  readonly paymentNotes?: Maybe<Scalars['String']>;
  readonly totalCost: Money;
  readonly wasFulfilled: Scalars['Boolean'];
};

export type PageInfo = {
  readonly __typename?: 'PageInfo';
  readonly hasPreviousPage: Scalars['Boolean'];
  readonly startCursor: Scalars['String'];
  readonly hasNextPage: Scalars['Boolean'];
  readonly endCursor: Scalars['String'];
};

export type PortalUser = {
  readonly __typename?: 'PortalUser';
  readonly id: Scalars['UUID'];
  readonly email: Scalars['String'];
  readonly username: Scalars['String'];
  readonly firstName: Scalars['String'];
  readonly lastName: Scalars['String'];
};

export type ProductDetails = {
  readonly __typename?: 'ProductDetails';
  readonly id: Scalars['Int'];
  readonly name: Scalars['String'];
  readonly unitPrice: Money;
};

export type Query = {
  readonly __typename?: 'Query';
  readonly ping: Scalars['String'];
  readonly league?: Maybe<League>;
  readonly divisions: ReadonlyArray<LeagueDivision>;
  readonly divisionsBySeason: ReadonlyArray<LeagueDivision>;
  readonly divisionsByTeamGroup: ReadonlyArray<LeagueDivision>;
  readonly teamGroupsBySeason: ReadonlyArray<TeamGroup>;
  readonly teamsByDivision: ReadonlyArray<Team>;
  readonly teamsByDivisionCorrect: ReadonlyArray<Team>;
  readonly games: ReadonlyArray<Game>;
  readonly game?: Maybe<Game>;
  readonly reportedGameScores: Scalars['String'];
  readonly cachedGames: ReadonlyArray<Game>;
  readonly seasonById?: Maybe<LeagueSeason>;
  readonly portalHomeContent?: Maybe<Scalars['String']>;
  readonly season?: Maybe<LeagueSeason>;
  readonly teams: ReadonlyArray<Team>;
  readonly team?: Maybe<Team>;
  readonly teamByGUID?: Maybe<Team>;
  readonly teamsInSameSeason: ReadonlyArray<Team>;
  readonly allGames: ReadonlyArray<GameV3>;
  readonly allGamesInRange: ReadonlyArray<GameV3>;
  readonly clientId: Scalars['String'];
  readonly tableInteractionEvents: ReadonlyArray<TableInteractionEvent>;
  readonly rawGames: ReadonlyArray<RawGame>;
  readonly fields: ReadonlyArray<Field>;
  readonly me?: Maybe<PortalUser>;
  readonly amIAdmin?: Maybe<Scalars['Boolean']>;
  readonly verifySession: Scalars['Boolean'];
  readonly verifyPasswordResetTokenIsValid: Scalars['Boolean'];
  readonly searchTeams: TeamConnection;
  readonly gameById?: Maybe<GameV3>;
  readonly gamesByIds: ReadonlyArray<GameV3>;
  readonly gamesForTeam: ReadonlyArray<GameV3>;
  readonly formById?: Maybe<GameForm>;
  readonly approvedGames: ReadonlyArray<GameV3>;
  readonly umpires: ReadonlyArray<Umpire>;
  readonly gamesByTeam: ReadonlyArray<GameV2>;
  readonly revenueBySeason?: Maybe<Money>;
};


export type QueryLeagueArgs = {
  id: Scalars['Int'];
};


export type QueryDivisionsBySeasonArgs = {
  seasonId: Scalars['Int'];
};


export type QueryDivisionsByTeamGroupArgs = {
  id: Scalars['Int'];
};


export type QueryTeamGroupsBySeasonArgs = {
  id: Scalars['Int'];
};


export type QueryTeamsByDivisionArgs = {
  divisionId: Scalars['Int'];
};


export type QueryTeamsByDivisionCorrectArgs = {
  divisionId: Scalars['Int'];
};


export type QueryGameArgs = {
  id: Scalars['Int'];
};


export type QuerySeasonByIdArgs = {
  id: Scalars['Int'];
};


export type QuerySeasonArgs = {
  id: Scalars['Int'];
};


export type QueryTeamsArgs = {
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['Int']>;
};


export type QueryTeamArgs = {
  id: Scalars['Int'];
};


export type QueryTeamByGuidArgs = {
  guid: Scalars['UUID'];
};


export type QueryTeamsInSameSeasonArgs = {
  viewingTeamId: Scalars['Int'];
};


export type QueryAllGamesArgs = {
  seasonId: Scalars['Int'];
};


export type QueryAllGamesInRangeArgs = {
  seasonId: Scalars['Int'];
  start: Scalars['Date'];
  end: Scalars['Date'];
};


export type QueryRawGamesArgs = {
  enteringTeamId: Scalars['Int'];
};


export type QueryVerifyPasswordResetTokenIsValidArgs = {
  token: Scalars['String'];
};


export type QuerySearchTeamsArgs = {
  query?: Maybe<Scalars['String']>;
  first?: Scalars['Int'];
  after?: Maybe<Scalars['String']>;
};


export type QueryGameByIdArgs = {
  id: Scalars['Int'];
};


export type QueryGamesByIdsArgs = {
  ids: ReadonlyArray<Scalars['Int']>;
};


export type QueryGamesForTeamArgs = {
  id: Scalars['Int'];
};


export type QueryFormByIdArgs = {
  id: Scalars['Int'];
};


export type QueryApprovedGamesArgs = {
  seasonId: Scalars['Int'];
};


export type QueryGamesByTeamArgs = {
  teamId: Scalars['Int'];
};


export type QueryRevenueBySeasonArgs = {
  seasonId: Scalars['Int'];
};

export type RawGame = {
  readonly __typename?: 'RawGame';
  readonly id: Scalars['Int'];
  readonly enteringTeam: Team;
  readonly opponentTeam?: Maybe<Team>;
  readonly field?: Maybe<Field>;
  readonly date?: Maybe<Scalars['Date']>;
  readonly time?: Maybe<Scalars['Time']>;
  readonly dateTime: Scalars['DateTime'];
  readonly verificationState: RawGameVerificationState;
  readonly isHomeGameForEnteringTeam: Scalars['Boolean'];
};

export type RawGameUpdates = {
  readonly __typename?: 'RawGameUpdates';
  readonly update?: Maybe<RawGame>;
  readonly delete?: Maybe<Scalars['Boolean']>;
  readonly setOpponentTeam?: Maybe<RawGame>;
  readonly setDate?: Maybe<RawGame>;
  readonly setTime?: Maybe<RawGame>;
  readonly setField?: Maybe<RawGame>;
  readonly setIsHomeGame?: Maybe<RawGame>;
};


export type RawGameUpdatesUpdateArgs = {
  gameId: Scalars['Int'];
  data: CreateRawGameInput;
};


export type RawGameUpdatesDeleteArgs = {
  gameId: Scalars['Int'];
};


export type RawGameUpdatesSetOpponentTeamArgs = {
  gameId: Scalars['Int'];
  teamId: Scalars['Int'];
};


export type RawGameUpdatesSetDateArgs = {
  gameId: Scalars['Int'];
  date: Scalars['Date'];
};


export type RawGameUpdatesSetTimeArgs = {
  gameId: Scalars['Int'];
  time: Scalars['Time'];
};


export type RawGameUpdatesSetFieldArgs = {
  gameId: Scalars['Int'];
  fieldId: Scalars['Int'];
};


export type RawGameUpdatesSetIsHomeGameArgs = {
  gameId: Scalars['Int'];
  isHomeGame: Scalars['Boolean'];
};

export enum RawGameVerificationState {
  Unverified = 'UNVERIFIED',
  TimeUnverified = 'TIME_UNVERIFIED',
  FieldUnverified = 'FIELD_UNVERIFIED',
  HomeGameStateUnverified = 'HOME_GAME_STATE_UNVERIFIED',
  Verified = 'VERIFIED'
}

export type RegisterTeamInput = {
  readonly teamName: Scalars['String'];
  readonly divisionId: Scalars['Int'];
  readonly zipcode: Scalars['String'];
  readonly headCoachName: Scalars['String'];
  readonly headCoachEmail: Scalars['String'];
  readonly headCoachCell: Scalars['String'];
  readonly schedulerName: Scalars['String'];
  readonly schedulerEmail: Scalars['String'];
  readonly schedulerCell: Scalars['String'];
  readonly dozensOfBalls?: Maybe<Scalars['Int']>;
};

export type ReportGameScoreInput = {
  readonly enteringTeamId: Scalars['Int'];
  readonly homeTeamRuns: Scalars['Int'];
  readonly awayTeamRuns: Scalars['Int'];
  readonly primaryUmpireRating?: Maybe<Scalars['Int']>;
  readonly secondaryUmpireRating?: Maybe<Scalars['Int']>;
  readonly comments?: Maybe<Scalars['String']>;
};

export type Requirement = {
  readonly __typename?: 'Requirement';
  readonly id: Scalars['Int'];
  readonly name?: Maybe<Scalars['String']>;
  readonly description?: Maybe<Scalars['String']>;
  readonly formDownloadUrl?: Maybe<Scalars['String']>;
};

export type RequirementStatus = {
  readonly __typename?: 'RequirementStatus';
  readonly id: Scalars['Int'];
  readonly requirement: Requirement;
  readonly isFulfilled: Scalars['Boolean'];
  readonly fileUrl?: Maybe<Scalars['String']>;
};

export type RequirementUpdates = {
  readonly __typename?: 'RequirementUpdates';
  readonly setRequirementStatus?: Maybe<RequirementStatus>;
};


export type RequirementUpdatesSetRequirementStatusArgs = {
  teamId: Scalars['Int'];
  requirementId: Scalars['Int'];
  status: Scalars['Boolean'];
  fileId?: Maybe<Scalars['String']>;
};

export type RescheduleGameInput = {
  readonly date: Scalars['Date'];
  readonly time: Scalars['Time'];
  readonly fieldId: Scalars['Int'];
  readonly enteringTeamIsHomeTeam?: Maybe<Scalars['Boolean']>;
};

export type SearchTeamsInput = {
  readonly query?: Maybe<Scalars['String']>;
  readonly first?: Maybe<Scalars['Int']>;
  readonly after?: Maybe<Scalars['String']>;
  readonly last?: Maybe<Scalars['Int']>;
  readonly before?: Maybe<Scalars['String']>;
};

export type Subscription = {
  readonly __typename?: 'Subscription';
  readonly tableInteractionEvents: TableInteractionEvent;
};

export type SuccessfulAuthResponse = {
  readonly __typename?: 'SuccessfulAuthResponse';
  readonly user: PortalUser;
};

export type SuccessfulCreateAccountResponse = {
  readonly __typename?: 'SuccessfulCreateAccountResponse';
  readonly user: PortalUser;
};

/**
 * interface GameChangeRequestState {
 *     timestamp: DateTime!
 * }
 * 
 * type GameChangeRequestAcceptedState implements GameChangeRequestState {
 *     timestamp: DateTime!
 * }
 * 
 * type GameChangeRequestDeclinedState implements GameChangeRequestState {
 *     timestamp: DateTime!
 *     comment: String
 * }
 */
export type T = {
  readonly __typename?: 'T';
  readonly id?: Maybe<Scalars['Boolean']>;
};

export type TableInteractionEvent = {
  readonly __typename?: 'TableInteractionEvent';
  readonly clientId: Scalars['String'];
  readonly entityId?: Maybe<Scalars['String']>;
  readonly entityFieldIdentifier?: Maybe<Scalars['String']>;
  readonly tableIdentifier?: Maybe<Scalars['String']>;
};

export type Team = {
  readonly __typename?: 'Team';
  readonly id: Scalars['Int'];
  readonly guid?: Maybe<Scalars['String']>;
  readonly name: Scalars['String'];
  readonly division: LeagueDivision;
  readonly zipcode: Scalars['String'];
  readonly location?: Maybe<Location>;
  readonly headCoachName: Scalars['String'];
  readonly headCoachEmail: Scalars['String'];
  readonly headCoachCell: Scalars['String'];
  readonly schedulerName: Scalars['String'];
  readonly schedulerEmail: Scalars['String'];
  readonly schedulerCell: Scalars['String'];
  readonly financials: TeamFinancialData;
  readonly requirementStatus: TeamRequirementData;
  readonly games: ReadonlyArray<Game>;
  readonly numberOfGames: Scalars['Int'];
  readonly submittedGameScoreIds: ReadonlyArray<Scalars['Int']>;
  readonly record?: Maybe<Scalars['String']>;
  readonly runsFor: Scalars['Int'];
  readonly runsAgainst: Scalars['Int'];
  readonly leaguePoints: Scalars['Int'];
  readonly leagueSeed?: Maybe<Scalars['Int']>;
  readonly isCommittedToPlayoffs?: Maybe<Scalars['Boolean']>;
  readonly currentStreak: Scalars['String'];
  readonly expectedRecord: Scalars['String'];
  readonly recordOverLastTenGames: Scalars['String'];
  readonly winPercentage?: Maybe<Scalars['Float']>;
  readonly percentageOfMaxPointsEarned?: Maybe<Scalars['Float']>;
  readonly confirmedGameCount: Scalars['Int'];
  readonly unconfirmedGameCount: Scalars['Int'];
};


export type TeamNameArgs = {
  format?: TeamNameFormat;
};

export type TeamConnection = {
  readonly __typename?: 'TeamConnection';
  readonly edges: ReadonlyArray<TeamEdge>;
  readonly pageInfo: PageInfo;
};

export type TeamEdge = {
  readonly __typename?: 'TeamEdge';
  readonly cursor: Scalars['String'];
  readonly node: Team;
};

export type TeamFinancialData = {
  readonly __typename?: 'TeamFinancialData';
  readonly orders: ReadonlyArray<Order>;
  readonly outstandingBalance: Money;
};

export type TeamGroup = {
  readonly __typename?: 'TeamGroup';
  readonly id: Scalars['Int'];
  readonly name: Scalars['String'];
  readonly rank: Scalars['String'];
  readonly description?: Maybe<Scalars['String']>;
};

export enum TeamNameFormat {
  None = 'NONE',
  WithDivisionOnly = 'WITH_DIVISION_ONLY',
  WithDivisionAndModifier = 'WITH_DIVISION_AND_MODIFIER'
}

export type TeamRequirementData = {
  readonly __typename?: 'TeamRequirementData';
  readonly requirementStatuses: ReadonlyArray<RequirementStatus>;
  readonly inGoodStanding: Scalars['Boolean'];
};

export type TeamUpdates = {
  readonly __typename?: 'TeamUpdates';
  readonly deleteTeam?: Maybe<Scalars['Int']>;
  readonly setName?: Maybe<Team>;
  readonly setDivision?: Maybe<Team>;
  readonly setHeadCoachName?: Maybe<Team>;
  readonly setHeadCoachEmail?: Maybe<Team>;
  readonly setHeadCoachCell?: Maybe<Team>;
  readonly setSchedulerName?: Maybe<Team>;
  readonly setSchedulerEmail?: Maybe<Team>;
  readonly setSchedulerCell?: Maybe<Team>;
  readonly setZipcode?: Maybe<Team>;
  readonly setIsCommittedToPlayoffs?: Maybe<Team>;
};


export type TeamUpdatesDeleteTeamArgs = {
  id: Scalars['Int'];
};


export type TeamUpdatesSetNameArgs = {
  id: Scalars['Int'];
  name: Scalars['String'];
};


export type TeamUpdatesSetDivisionArgs = {
  id: Scalars['Int'];
  divisionId: Scalars['Int'];
};


export type TeamUpdatesSetHeadCoachNameArgs = {
  id: Scalars['Int'];
  name: Scalars['String'];
};


export type TeamUpdatesSetHeadCoachEmailArgs = {
  id: Scalars['Int'];
  email: Scalars['String'];
};


export type TeamUpdatesSetHeadCoachCellArgs = {
  id: Scalars['Int'];
  cellNumber: Scalars['String'];
};


export type TeamUpdatesSetSchedulerNameArgs = {
  id: Scalars['Int'];
  name: Scalars['String'];
};


export type TeamUpdatesSetSchedulerEmailArgs = {
  id: Scalars['Int'];
  email: Scalars['String'];
};


export type TeamUpdatesSetSchedulerCellArgs = {
  id: Scalars['Int'];
  cellNumber: Scalars['String'];
};


export type TeamUpdatesSetZipcodeArgs = {
  id: Scalars['Int'];
  zipcode: Scalars['String'];
};


export type TeamUpdatesSetIsCommittedToPlayoffsArgs = {
  id: Scalars['Int'];
  status: Scalars['Boolean'];
};



export type Umpire = {
  readonly __typename?: 'Umpire';
  readonly id: Scalars['Int'];
  readonly firstName: Scalars['String'];
  readonly lastName: Scalars['String'];
  readonly email?: Maybe<Scalars['String']>;
  readonly phoneNumber?: Maybe<Scalars['String']>;
  readonly location?: Maybe<Scalars['String']>;
};

export type UpdateOrderPaymentStatusPayload = {
  readonly __typename?: 'UpdateOrderPaymentStatusPayload';
  readonly success: Scalars['Boolean'];
  readonly order?: Maybe<Order>;
};

export type VerifiedGame = {
  readonly __typename?: 'VerifiedGame';
  readonly homeTeam: Team;
  readonly awayTeam: Team;
  readonly date: Scalars['Date'];
  readonly time: Scalars['Time'];
  readonly homeTeamScore?: Maybe<Scalars['Int']>;
  readonly awayTeamScore?: Maybe<Scalars['Int']>;
};

export type AuthenticateMutationVariables = Exact<{
  usernameOrEmail: Scalars['String'];
  password: Scalars['String'];
}>;


export type AuthenticateMutation = { readonly __typename?: 'Mutation', readonly authenticate: { readonly __typename?: 'SuccessfulAuthResponse', readonly user: { readonly __typename?: 'PortalUser', readonly id: any, readonly firstName: string, readonly lastName: string, readonly email: string } } | { readonly __typename?: 'FailedAuthResponse', readonly message: string } };

export type CompleteAccountCreationMutationVariables = Exact<{
  userId: Scalars['UUID'];
  username: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
}>;


export type CompleteAccountCreationMutation = { readonly __typename?: 'Mutation', readonly updateUsername: { readonly __typename?: 'PortalUser', readonly id: any, readonly username: string }, readonly updateFirstName: { readonly __typename?: 'PortalUser', readonly id: any, readonly firstName: string }, readonly updateLastName: { readonly __typename?: 'PortalUser', readonly id: any, readonly lastName: string } };

export type CreateAccountMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type CreateAccountMutation = { readonly __typename?: 'Mutation', readonly createAccount: { readonly __typename?: 'SuccessfulCreateAccountResponse', readonly user: { readonly __typename?: 'PortalUser', readonly id: any, readonly email: string } } | { readonly __typename?: 'FailedCreateAccountResponse', readonly message: string } };

export type CreateCheckoutForOrdersMutationVariables = Exact<{
  orderIds: ReadonlyArray<Scalars['Int']>;
}>;


export type CreateCheckoutForOrdersMutation = { readonly __typename?: 'Mutation', readonly createCheckoutSessionForOrderIds?: Maybe<string> };

export type CreateRawGameMutationVariables = Exact<{
  enteringTeamId: Scalars['Int'];
  createRawGameData: CreateRawGameInput;
}>;


export type CreateRawGameMutation = { readonly __typename?: 'Mutation', readonly createRawGame: { readonly __typename?: 'RawGame', readonly id: number, readonly date?: Maybe<any>, readonly time?: Maybe<any>, readonly dateTime: any, readonly enteringTeam: { readonly __typename?: 'Team', readonly id: number, readonly name: string }, readonly opponentTeam?: Maybe<{ readonly __typename?: 'Team', readonly id: number, readonly name: string }>, readonly field?: Maybe<{ readonly __typename?: 'Field', readonly id: number, readonly name: string }> } };

export type DeleteRawGameMutationVariables = Exact<{
  gameId: Scalars['Int'];
}>;


export type DeleteRawGameMutation = { readonly __typename?: 'Mutation', readonly updateRawGame: { readonly __typename?: 'RawGameUpdates', readonly delete?: Maybe<boolean> } };

export type AddGameForTeamMutationVariables = Exact<{
  data: CreateGameInput;
}>;


export type AddGameForTeamMutation = { readonly __typename?: 'Mutation', readonly createGame?: Maybe<{ readonly __typename?: 'GameV2', readonly id: string, readonly date: any, readonly time: any, readonly dateTime: any, readonly isConfirmed?: Maybe<boolean>, readonly syncToken: string, readonly homeTeam: { readonly __typename?: 'Team', readonly id: number, readonly name: string }, readonly awayTeam: { readonly __typename?: 'Team', readonly id: number, readonly name: string }, readonly field: { readonly __typename?: 'Field', readonly id: number, readonly name: string }, readonly createdBy: { readonly __typename?: 'Team', readonly id: number, readonly name: string }, readonly cancelStatus?: Maybe<{ readonly __typename?: 'CancelledGameInfo', readonly cancelReason?: Maybe<string>, readonly rescheduledGame?: Maybe<{ readonly __typename?: 'Game', readonly id: number }> }> }> };

export type ConfirmGameMutationVariables = Exact<{
  gameId: Scalars['Int'];
  syncToken: Scalars['String'];
}>;


export type ConfirmGameMutation = { readonly __typename?: 'Mutation', readonly confirmGame?: Maybe<{ readonly __typename?: 'GameV2', readonly id: string, readonly date: any, readonly time: any, readonly dateTime: any, readonly isConfirmed?: Maybe<boolean>, readonly syncToken: string, readonly homeTeam: { readonly __typename?: 'Team', readonly id: number, readonly name: string }, readonly awayTeam: { readonly __typename?: 'Team', readonly id: number, readonly name: string }, readonly field: { readonly __typename?: 'Field', readonly id: number, readonly name: string }, readonly createdBy: { readonly __typename?: 'Team', readonly id: number, readonly name: string }, readonly cancelStatus?: Maybe<{ readonly __typename?: 'CancelledGameInfo', readonly cancelReason?: Maybe<string>, readonly rescheduledGame?: Maybe<{ readonly __typename?: 'Game', readonly id: number }> }> }> };

export type AddGameMutationVariables = Exact<{
  data: AddGameInput;
}>;


export type AddGameMutation = { readonly __typename?: 'Mutation', readonly addGame?: Maybe<{ readonly __typename?: 'GameV3', readonly id: number, readonly createdBy: { readonly __typename?: 'Team', readonly id: number, readonly name: string }, readonly opponent: { readonly __typename?: 'Team', readonly id: number, readonly name: string }, readonly schedulingDetails?: Maybe<{ readonly __typename?: 'GameSchedulingDetails', readonly dateTime: any, readonly homeTeam: { readonly __typename?: 'Team', readonly id: number, readonly name: string }, readonly awayTeam: { readonly __typename?: 'Team', readonly id: number, readonly name: string }, readonly field: { readonly __typename?: 'Field', readonly id: number, readonly name: string } }> }> };

export type CancelGameMutationVariables = Exact<{
  gameId: Scalars['Int'];
  cancellationReason?: Maybe<Scalars['String']>;
}>;


export type CancelGameMutation = { readonly __typename?: 'Mutation', readonly cancelGame?: Maybe<{ readonly __typename?: 'GameV3', readonly id: number, readonly isCancelled: boolean, readonly createdBy: { readonly __typename?: 'Team', readonly id: number, readonly name: string, readonly displayName: string }, readonly opponent: { readonly __typename?: 'Team', readonly id: number, readonly name: string, readonly displayName: string }, readonly schedulingDetails?: Maybe<{ readonly __typename?: 'GameSchedulingDetails', readonly dateTime: any, readonly homeTeam: { readonly __typename?: 'Team', readonly id: number, readonly name: string, readonly displayName: string }, readonly awayTeam: { readonly __typename?: 'Team', readonly id: number, readonly name: string, readonly displayName: string }, readonly field: { readonly __typename?: 'Field', readonly id: number, readonly name: string } }>, readonly formHistory: ReadonlyArray<{ readonly __typename?: 'GameCancellationForm', readonly id: number, readonly timeCreated: any, readonly approvalStatus: GameFormApprovalStatus, readonly createdBy?: Maybe<{ readonly __typename?: 'Team', readonly id: number, readonly name: string, readonly displayName: string }>, readonly approvers: ReadonlyArray<{ readonly __typename?: 'GameFormApprover', readonly status: GameFormApprovalStatus, readonly statusLastUpdated: any, readonly team: { readonly __typename?: 'Team', readonly id: number, readonly name: string } }> } | { readonly __typename?: 'GameSchedulingForm', readonly gameDateTime: any, readonly isHomeGameForEnteringTeam: boolean, readonly id: number, readonly timeCreated: any, readonly approvalStatus: GameFormApprovalStatus, readonly gameField: { readonly __typename?: 'Field', readonly id: number, readonly name: string }, readonly createdBy?: Maybe<{ readonly __typename?: 'Team', readonly id: number, readonly name: string, readonly displayName: string }>, readonly approvers: ReadonlyArray<{ readonly __typename?: 'GameFormApprover', readonly status: GameFormApprovalStatus, readonly statusLastUpdated: any, readonly team: { readonly __typename?: 'Team', readonly id: number, readonly name: string } }> } | { readonly __typename?: 'GameScoreReportForm', readonly id: number, readonly timeCreated: any, readonly approvalStatus: GameFormApprovalStatus, readonly createdBy?: Maybe<{ readonly __typename?: 'Team', readonly id: number, readonly name: string, readonly displayName: string }>, readonly approvers: ReadonlyArray<{ readonly __typename?: 'GameFormApprover', readonly status: GameFormApprovalStatus, readonly statusLastUpdated: any, readonly team: { readonly __typename?: 'Team', readonly id: number, readonly name: string } }> } | { readonly __typename?: 'GameUmpireAssignmentForm', readonly id: number, readonly timeCreated: any, readonly approvalStatus: GameFormApprovalStatus, readonly createdBy?: Maybe<{ readonly __typename?: 'Team', readonly id: number, readonly name: string, readonly displayName: string }>, readonly approvers: ReadonlyArray<{ readonly __typename?: 'GameFormApprover', readonly status: GameFormApprovalStatus, readonly statusLastUpdated: any, readonly team: { readonly __typename?: 'Team', readonly id: number, readonly name: string } }> }> }> };

export type CreateGameSchedulingFormForGameMutationVariables = Exact<{
  gameId: Scalars['Int'];
  data: GameSchedulingFormInput;
  approvers?: Maybe<ReadonlyArray<GameFormApprovalInput>>;
}>;


export type CreateGameSchedulingFormForGameMutation = { readonly __typename?: 'Mutation', readonly createGameSchedulingChangeRequest?: Maybe<{ readonly __typename?: 'GameV3', readonly id: number, readonly createdBy: { readonly __typename?: 'Team', readonly id: number, readonly name: string }, readonly opponent: { readonly __typename?: 'Team', readonly id: number, readonly name: string }, readonly schedulingDetails?: Maybe<{ readonly __typename?: 'GameSchedulingDetails', readonly dateTime: any, readonly homeTeam: { readonly __typename?: 'Team', readonly id: number, readonly name: string }, readonly awayTeam: { readonly __typename?: 'Team', readonly id: number, readonly name: string }, readonly field: { readonly __typename?: 'Field', readonly id: number, readonly name: string } }>, readonly formHistory: ReadonlyArray<{ readonly __typename?: 'GameCancellationForm', readonly id: number, readonly timeCreated: any, readonly approvalStatus: GameFormApprovalStatus, readonly createdBy?: Maybe<{ readonly __typename?: 'Team', readonly id: number, readonly name: string }>, readonly approvers: ReadonlyArray<{ readonly __typename?: 'GameFormApprover', readonly status: GameFormApprovalStatus, readonly statusLastUpdated: any, readonly team: { readonly __typename?: 'Team', readonly id: number, readonly name: string } }> } | { readonly __typename?: 'GameSchedulingForm', readonly gameDateTime: any, readonly isHomeGameForEnteringTeam: boolean, readonly id: number, readonly timeCreated: any, readonly approvalStatus: GameFormApprovalStatus, readonly gameField: { readonly __typename?: 'Field', readonly id: number, readonly name: string }, readonly createdBy?: Maybe<{ readonly __typename?: 'Team', readonly id: number, readonly name: string }>, readonly approvers: ReadonlyArray<{ readonly __typename?: 'GameFormApprover', readonly status: GameFormApprovalStatus, readonly statusLastUpdated: any, readonly team: { readonly __typename?: 'Team', readonly id: number, readonly name: string } }> } | { readonly __typename?: 'GameScoreReportForm', readonly id: number, readonly timeCreated: any, readonly approvalStatus: GameFormApprovalStatus, readonly createdBy?: Maybe<{ readonly __typename?: 'Team', readonly id: number, readonly name: string }>, readonly approvers: ReadonlyArray<{ readonly __typename?: 'GameFormApprover', readonly status: GameFormApprovalStatus, readonly statusLastUpdated: any, readonly team: { readonly __typename?: 'Team', readonly id: number, readonly name: string } }> } | { readonly __typename?: 'GameUmpireAssignmentForm', readonly id: number, readonly timeCreated: any, readonly approvalStatus: GameFormApprovalStatus, readonly createdBy?: Maybe<{ readonly __typename?: 'Team', readonly id: number, readonly name: string }>, readonly approvers: ReadonlyArray<{ readonly __typename?: 'GameFormApprover', readonly status: GameFormApprovalStatus, readonly statusLastUpdated: any, readonly team: { readonly __typename?: 'Team', readonly id: number, readonly name: string } }> }> }> };

export type UpdateFormApprovalStatusForTeamMutationVariables = Exact<{
  formId: Scalars['Int'];
  status: Scalars['String'];
}>;


export type UpdateFormApprovalStatusForTeamMutation = { readonly __typename?: 'Mutation', readonly updateFormApprovalStatusForTeam?: Maybe<{ readonly __typename?: 'GameV3', readonly id: number, readonly createdBy: { readonly __typename?: 'Team', readonly id: number, readonly name: string }, readonly opponent: { readonly __typename?: 'Team', readonly id: number, readonly name: string }, readonly schedulingDetails?: Maybe<{ readonly __typename?: 'GameSchedulingDetails', readonly dateTime: any, readonly homeTeam: { readonly __typename?: 'Team', readonly id: number, readonly name: string }, readonly awayTeam: { readonly __typename?: 'Team', readonly id: number, readonly name: string }, readonly field: { readonly __typename?: 'Field', readonly id: number, readonly name: string } }>, readonly formHistory: ReadonlyArray<{ readonly __typename?: 'GameCancellationForm', readonly id: number, readonly timeCreated: any, readonly approvalStatus: GameFormApprovalStatus, readonly createdBy?: Maybe<{ readonly __typename?: 'Team', readonly id: number, readonly name: string }>, readonly approvers: ReadonlyArray<{ readonly __typename?: 'GameFormApprover', readonly status: GameFormApprovalStatus, readonly statusLastUpdated: any, readonly team: { readonly __typename?: 'Team', readonly id: number, readonly name: string } }> } | { readonly __typename?: 'GameSchedulingForm', readonly gameDateTime: any, readonly isHomeGameForEnteringTeam: boolean, readonly id: number, readonly timeCreated: any, readonly approvalStatus: GameFormApprovalStatus, readonly gameField: { readonly __typename?: 'Field', readonly id: number, readonly name: string }, readonly createdBy?: Maybe<{ readonly __typename?: 'Team', readonly id: number, readonly name: string }>, readonly approvers: ReadonlyArray<{ readonly __typename?: 'GameFormApprover', readonly status: GameFormApprovalStatus, readonly statusLastUpdated: any, readonly team: { readonly __typename?: 'Team', readonly id: number, readonly name: string } }> } | { readonly __typename?: 'GameScoreReportForm', readonly id: number, readonly timeCreated: any, readonly approvalStatus: GameFormApprovalStatus, readonly createdBy?: Maybe<{ readonly __typename?: 'Team', readonly id: number, readonly name: string }>, readonly approvers: ReadonlyArray<{ readonly __typename?: 'GameFormApprover', readonly status: GameFormApprovalStatus, readonly statusLastUpdated: any, readonly team: { readonly __typename?: 'Team', readonly id: number, readonly name: string } }> } | { readonly __typename?: 'GameUmpireAssignmentForm', readonly id: number, readonly timeCreated: any, readonly approvalStatus: GameFormApprovalStatus, readonly createdBy?: Maybe<{ readonly __typename?: 'Team', readonly id: number, readonly name: string }>, readonly approvers: ReadonlyArray<{ readonly __typename?: 'GameFormApprover', readonly status: GameFormApprovalStatus, readonly statusLastUpdated: any, readonly team: { readonly __typename?: 'Team', readonly id: number, readonly name: string } }> }> }> };

export type RejectGameMutationVariables = Exact<{
  gameId: Scalars['Int'];
  syncToken: Scalars['String'];
}>;


export type RejectGameMutation = { readonly __typename?: 'Mutation', readonly rejectGame?: Maybe<{ readonly __typename?: 'GameV2', readonly id: string, readonly date: any, readonly time: any, readonly dateTime: any, readonly isConfirmed?: Maybe<boolean>, readonly syncToken: string, readonly homeTeam: { readonly __typename?: 'Team', readonly id: number, readonly name: string }, readonly awayTeam: { readonly __typename?: 'Team', readonly id: number, readonly name: string }, readonly field: { readonly __typename?: 'Field', readonly id: number, readonly name: string }, readonly createdBy: { readonly __typename?: 'Team', readonly id: number, readonly name: string }, readonly cancelStatus?: Maybe<{ readonly __typename?: 'CancelledGameInfo', readonly cancelReason?: Maybe<string>, readonly rescheduledGame?: Maybe<{ readonly __typename?: 'Game', readonly id: number }> }> }> };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { readonly __typename?: 'Mutation', readonly logout: boolean };

export type PlaceOrderForTeamMutationVariables = Exact<{
  data: CreateOrderInput;
}>;


export type PlaceOrderForTeamMutation = { readonly __typename?: 'Mutation', readonly createOrder: { readonly __typename?: 'CreateOrderPayload', readonly success: boolean, readonly order?: Maybe<{ readonly __typename?: 'Order', readonly id: number, readonly didReceivePayment: boolean, readonly paymentNotes?: Maybe<string>, readonly quantity: number, readonly totalCost: { readonly __typename?: 'Money', readonly amount: any }, readonly productDetails: { readonly __typename?: 'ProductDetails', readonly id: number, readonly name: string, readonly unitPrice: { readonly __typename?: 'Money', readonly amount: any, readonly currencyCode: CurrencyCode } } }> } };

export type RequestPasswordResetMutationVariables = Exact<{
  emailOrUsername: Scalars['String'];
}>;


export type RequestPasswordResetMutation = { readonly __typename?: 'Mutation', readonly requestPasswordReset?: Maybe<boolean> };

export type ResendPortalUrlsMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type ResendPortalUrlsMutation = { readonly __typename?: 'Mutation', readonly sendPortalLinks?: Maybe<boolean> };

export type ResetPasswordMutationVariables = Exact<{
  token: Scalars['String'];
  password: Scalars['String'];
}>;


export type ResetPasswordMutation = { readonly __typename?: 'Mutation', readonly resetPassword?: Maybe<boolean> };

export type SetIsCommittedToPlayoffsMutationVariables = Exact<{
  teamId: Scalars['Int'];
  status: Scalars['Boolean'];
}>;


export type SetIsCommittedToPlayoffsMutation = { readonly __typename?: 'Mutation', readonly updateTeam: { readonly __typename?: 'TeamUpdates', readonly setIsCommittedToPlayoffs?: Maybe<{ readonly __typename?: 'Team', readonly id: number, readonly isCommittedToPlayoffs?: Maybe<boolean> }> } };

export type UpdateOrderFulfilmentStatusMutationVariables = Exact<{
  orderId: Scalars['Int'];
  status: Scalars['Boolean'];
}>;


export type UpdateOrderFulfilmentStatusMutation = { readonly __typename?: 'Mutation', readonly updateOrderFulfilmentStatus?: Maybe<{ readonly __typename?: 'Order', readonly id: number, readonly wasFulfilled: boolean }> };

export type UpdateOrderPaymentStatusMutationVariables = Exact<{
  orderId: Scalars['Int'];
  paymentStatus: Scalars['Boolean'];
  paymentNotes?: Maybe<Scalars['String']>;
}>;


export type UpdateOrderPaymentStatusMutation = { readonly __typename?: 'Mutation', readonly updateOrderPaymentStatus: { readonly __typename?: 'UpdateOrderPaymentStatusPayload', readonly order?: Maybe<{ readonly __typename?: 'Order', readonly id: number, readonly didReceivePayment: boolean, readonly paymentNotes?: Maybe<string> }> } };

export type UpdateOrderQuantityMutationVariables = Exact<{
  orderId: Scalars['Int'];
  quantity: Scalars['Int'];
}>;


export type UpdateOrderQuantityMutation = { readonly __typename?: 'Mutation', readonly updateOrderQuantity?: Maybe<{ readonly __typename?: 'Order', readonly id: number, readonly didReceivePayment: boolean, readonly paymentNotes?: Maybe<string>, readonly quantity: number, readonly totalCost: { readonly __typename?: 'Money', readonly amount: any }, readonly productDetails: { readonly __typename?: 'ProductDetails', readonly id: number, readonly name: string, readonly unitPrice: { readonly __typename?: 'Money', readonly amount: any, readonly currencyCode: CurrencyCode } } }> };

export type UpdateRawGameMutationVariables = Exact<{
  gameId: Scalars['Int'];
  data: CreateRawGameInput;
}>;


export type UpdateRawGameMutation = { readonly __typename?: 'Mutation', readonly updateRawGame: { readonly __typename?: 'RawGameUpdates', readonly update?: Maybe<{ readonly __typename?: 'RawGame', readonly id: number, readonly date?: Maybe<any>, readonly time?: Maybe<any>, readonly dateTime: any, readonly enteringTeam: { readonly __typename?: 'Team', readonly id: number, readonly name: string }, readonly opponentTeam?: Maybe<{ readonly __typename?: 'Team', readonly id: number, readonly name: string }>, readonly field?: Maybe<{ readonly __typename?: 'Field', readonly id: number, readonly name: string }> }> } };

export type UpdateTeamRequirementStatusMutationVariables = Exact<{
  teamId: Scalars['Int'];
  requirementId: Scalars['Int'];
  status: Scalars['Boolean'];
  fileId?: Maybe<Scalars['String']>;
}>;


export type UpdateTeamRequirementStatusMutation = { readonly __typename?: 'Mutation', readonly updateRequirements: { readonly __typename?: 'RequirementUpdates', readonly setRequirementStatus?: Maybe<{ readonly __typename?: 'RequirementStatus', readonly id: number, readonly isFulfilled: boolean, readonly fileUrl?: Maybe<string> }> } };

export type VerifyEmailMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type VerifyEmailMutation = { readonly __typename?: 'Mutation', readonly verifyEmailAddress: boolean };

export type BasicTeamInfoFragment = { readonly __typename?: 'Team', readonly id: number, readonly name: string };

export type AllFieldsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllFieldsQuery = { readonly __typename?: 'Query', readonly fields: ReadonlyArray<{ readonly __typename?: 'Field', readonly id: number, readonly name: string }> };

export type AllTeamsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllTeamsQuery = { readonly __typename?: 'Query', readonly teams: ReadonlyArray<{ readonly __typename?: 'Team', readonly id: number, readonly name: string, readonly division: { readonly __typename?: 'LeagueDivision', readonly id: number, readonly rank: number, readonly modifier?: Maybe<{ readonly __typename?: 'DivisionModifier', readonly id: number, readonly rank: number }> }, readonly location?: Maybe<{ readonly __typename?: 'Location', readonly latitude: string, readonly longitude: string }> }> };

export type AllTeamsInSeasonQueryVariables = Exact<{
  viewingTeamId: Scalars['Int'];
}>;


export type AllTeamsInSeasonQuery = { readonly __typename?: 'Query', readonly teamsInSameSeason: ReadonlyArray<{ readonly __typename?: 'Team', readonly id: number, readonly name: string, readonly division: { readonly __typename?: 'LeagueDivision', readonly id: number, readonly rank: number, readonly modifier?: Maybe<{ readonly __typename?: 'DivisionModifier', readonly id: number, readonly rank: number }> }, readonly location?: Maybe<{ readonly __typename?: 'Location', readonly latitude: string, readonly longitude: string }> }> };

export type AmIAdminQueryVariables = Exact<{ [key: string]: never; }>;


export type AmIAdminQuery = { readonly __typename?: 'Query', readonly amIAdmin?: Maybe<boolean> };

export type GameFormByIdQueryVariables = Exact<{
  formId: Scalars['Int'];
}>;


export type GameFormByIdQuery = { readonly __typename?: 'Query', readonly formById?: Maybe<{ readonly __typename?: 'GameCancellationForm', readonly id: number, readonly timeCreated: any, readonly approvalStatus: GameFormApprovalStatus, readonly createdBy?: Maybe<{ readonly __typename?: 'Team', readonly id: number, readonly name: string, readonly displayName: string }>, readonly approvers: ReadonlyArray<{ readonly __typename?: 'GameFormApprover', readonly status: GameFormApprovalStatus, readonly statusLastUpdated: any, readonly team: { readonly __typename?: 'Team', readonly id: number, readonly name: string } }> } | { readonly __typename?: 'GameSchedulingForm', readonly gameDateTime: any, readonly isHomeGameForEnteringTeam: boolean, readonly id: number, readonly timeCreated: any, readonly approvalStatus: GameFormApprovalStatus, readonly gameField: { readonly __typename?: 'Field', readonly id: number, readonly name: string }, readonly createdBy?: Maybe<{ readonly __typename?: 'Team', readonly id: number, readonly name: string, readonly displayName: string }>, readonly approvers: ReadonlyArray<{ readonly __typename?: 'GameFormApprover', readonly status: GameFormApprovalStatus, readonly statusLastUpdated: any, readonly team: { readonly __typename?: 'Team', readonly id: number, readonly name: string } }> } | { readonly __typename?: 'GameScoreReportForm', readonly id: number, readonly timeCreated: any, readonly approvalStatus: GameFormApprovalStatus, readonly createdBy?: Maybe<{ readonly __typename?: 'Team', readonly id: number, readonly name: string, readonly displayName: string }>, readonly approvers: ReadonlyArray<{ readonly __typename?: 'GameFormApprover', readonly status: GameFormApprovalStatus, readonly statusLastUpdated: any, readonly team: { readonly __typename?: 'Team', readonly id: number, readonly name: string } }> } | { readonly __typename?: 'GameUmpireAssignmentForm', readonly id: number, readonly timeCreated: any, readonly approvalStatus: GameFormApprovalStatus, readonly createdBy?: Maybe<{ readonly __typename?: 'Team', readonly id: number, readonly name: string, readonly displayName: string }>, readonly approvers: ReadonlyArray<{ readonly __typename?: 'GameFormApprover', readonly status: GameFormApprovalStatus, readonly statusLastUpdated: any, readonly team: { readonly __typename?: 'Team', readonly id: number, readonly name: string } }> }> };

export type GamesByTeamQueryVariables = Exact<{
  teamId: Scalars['Int'];
}>;


export type GamesByTeamQuery = { readonly __typename?: 'Query', readonly gamesForTeam: ReadonlyArray<{ readonly __typename?: 'GameV3', readonly id: number, readonly isCancelled: boolean, readonly primaryUmpire?: Maybe<{ readonly __typename?: 'Umpire', readonly firstName: string, readonly lastName: string, readonly phoneNumber?: Maybe<string> }>, readonly secondaryUmpire?: Maybe<{ readonly __typename?: 'Umpire', readonly firstName: string, readonly lastName: string, readonly phoneNumber?: Maybe<string> }>, readonly createdBy: { readonly __typename?: 'Team', readonly id: number, readonly name: string, readonly displayName: string }, readonly opponent: { readonly __typename?: 'Team', readonly id: number, readonly name: string, readonly displayName: string }, readonly schedulingDetails?: Maybe<{ readonly __typename?: 'GameSchedulingDetails', readonly dateTime: any, readonly homeTeam: { readonly __typename?: 'Team', readonly id: number, readonly name: string, readonly displayName: string }, readonly awayTeam: { readonly __typename?: 'Team', readonly id: number, readonly name: string, readonly displayName: string }, readonly field: { readonly __typename?: 'Field', readonly id: number, readonly name: string } }>, readonly formHistory: ReadonlyArray<{ readonly __typename?: 'GameCancellationForm', readonly id: number, readonly timeCreated: any, readonly approvalStatus: GameFormApprovalStatus, readonly createdBy?: Maybe<{ readonly __typename?: 'Team', readonly id: number, readonly name: string, readonly displayName: string }>, readonly approvers: ReadonlyArray<{ readonly __typename?: 'GameFormApprover', readonly status: GameFormApprovalStatus, readonly statusLastUpdated: any, readonly team: { readonly __typename?: 'Team', readonly id: number, readonly name: string } }> } | { readonly __typename?: 'GameSchedulingForm', readonly gameDateTime: any, readonly isHomeGameForEnteringTeam: boolean, readonly id: number, readonly timeCreated: any, readonly approvalStatus: GameFormApprovalStatus, readonly gameField: { readonly __typename?: 'Field', readonly id: number, readonly name: string }, readonly createdBy?: Maybe<{ readonly __typename?: 'Team', readonly id: number, readonly name: string, readonly displayName: string }>, readonly approvers: ReadonlyArray<{ readonly __typename?: 'GameFormApprover', readonly status: GameFormApprovalStatus, readonly statusLastUpdated: any, readonly team: { readonly __typename?: 'Team', readonly id: number, readonly name: string } }> } | { readonly __typename?: 'GameScoreReportForm', readonly id: number, readonly timeCreated: any, readonly approvalStatus: GameFormApprovalStatus, readonly createdBy?: Maybe<{ readonly __typename?: 'Team', readonly id: number, readonly name: string, readonly displayName: string }>, readonly approvers: ReadonlyArray<{ readonly __typename?: 'GameFormApprover', readonly status: GameFormApprovalStatus, readonly statusLastUpdated: any, readonly team: { readonly __typename?: 'Team', readonly id: number, readonly name: string } }> } | { readonly __typename?: 'GameUmpireAssignmentForm', readonly id: number, readonly timeCreated: any, readonly approvalStatus: GameFormApprovalStatus, readonly createdBy?: Maybe<{ readonly __typename?: 'Team', readonly id: number, readonly name: string, readonly displayName: string }>, readonly approvers: ReadonlyArray<{ readonly __typename?: 'GameFormApprover', readonly status: GameFormApprovalStatus, readonly statusLastUpdated: any, readonly team: { readonly __typename?: 'Team', readonly id: number, readonly name: string } }> }> }> };

export type GamesForTeamQueryVariables = Exact<{
  teamId: Scalars['Int'];
}>;


export type GamesForTeamQuery = { readonly __typename?: 'Query', readonly gamesByTeam: ReadonlyArray<{ readonly __typename?: 'GameV2', readonly id: string, readonly date: any, readonly time: any, readonly dateTime: any, readonly isConfirmed?: Maybe<boolean>, readonly syncToken: string, readonly homeTeam: { readonly __typename?: 'Team', readonly id: number, readonly name: string }, readonly awayTeam: { readonly __typename?: 'Team', readonly id: number, readonly name: string }, readonly field: { readonly __typename?: 'Field', readonly id: number, readonly name: string }, readonly createdBy: { readonly __typename?: 'Team', readonly id: number, readonly name: string }, readonly cancelStatus?: Maybe<{ readonly __typename?: 'CancelledGameInfo', readonly cancelReason?: Maybe<string>, readonly rescheduledGame?: Maybe<{ readonly __typename?: 'Game', readonly id: number }> }> }> };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { readonly __typename?: 'Query', readonly me?: Maybe<{ readonly __typename?: 'PortalUser', readonly id: any, readonly firstName: string, readonly lastName: string, readonly username: string, readonly email: string }> };

export type OrdersForTeamQueryVariables = Exact<{
  teamId: Scalars['Int'];
}>;


export type OrdersForTeamQuery = { readonly __typename?: 'Query', readonly team?: Maybe<{ readonly __typename?: 'Team', readonly financials: { readonly __typename?: 'TeamFinancialData', readonly outstandingBalance: { readonly __typename?: 'Money', readonly amount: any }, readonly orders: ReadonlyArray<{ readonly __typename?: 'Order', readonly id: number, readonly didReceivePayment: boolean, readonly paymentNotes?: Maybe<string>, readonly quantity: number, readonly wasFulfilled: boolean, readonly totalCost: { readonly __typename?: 'Money', readonly amount: any }, readonly productDetails: { readonly __typename?: 'ProductDetails', readonly id: number, readonly name: string, readonly unitPrice: { readonly __typename?: 'Money', readonly amount: any, readonly currencyCode: CurrencyCode } } }> } }> };

export type PortalHomeContentQueryVariables = Exact<{ [key: string]: never; }>;


export type PortalHomeContentQuery = { readonly __typename?: 'Query', readonly portalHomeContent?: Maybe<string> };

export type RawGamesForTeamQueryVariables = Exact<{
  teamId: Scalars['Int'];
}>;


export type RawGamesForTeamQuery = { readonly __typename?: 'Query', readonly rawGames: ReadonlyArray<{ readonly __typename?: 'RawGame', readonly id: number, readonly date?: Maybe<any>, readonly time?: Maybe<any>, readonly dateTime: any, readonly isHomeGameForEnteringTeam: boolean, readonly enteringTeam: { readonly __typename?: 'Team', readonly id: number, readonly name: string }, readonly opponentTeam?: Maybe<{ readonly __typename?: 'Team', readonly id: number, readonly name: string }>, readonly field?: Maybe<{ readonly __typename?: 'Field', readonly id: number, readonly name: string }> }> };

export type TeamByGuidQueryVariables = Exact<{
  guid: Scalars['UUID'];
}>;


export type TeamByGuidQuery = { readonly __typename?: 'Query', readonly team?: Maybe<{ readonly __typename?: 'Team', readonly id: number, readonly name: string, readonly headCoachName: string, readonly isCommittedToPlayoffs?: Maybe<boolean>, readonly displayName: string, readonly division: { readonly __typename?: 'LeagueDivision', readonly id: number, readonly rank: number, readonly name: string, readonly group: { readonly __typename?: 'TeamGroup', readonly id: number }, readonly modifier?: Maybe<{ readonly __typename?: 'DivisionModifier', readonly id: number, readonly rank: number }>, readonly season: { readonly __typename?: 'LeagueSeason', readonly id: number, readonly name: string } }, readonly location?: Maybe<{ readonly __typename?: 'Location', readonly latitude: string, readonly longitude: string }> }> };

export type TeamRequirementsQueryVariables = Exact<{
  teamId: Scalars['Int'];
}>;


export type TeamRequirementsQuery = { readonly __typename?: 'Query', readonly team?: Maybe<{ readonly __typename?: 'Team', readonly requirementStatus: { readonly __typename?: 'TeamRequirementData', readonly inGoodStanding: boolean, readonly requirementStatuses: ReadonlyArray<{ readonly __typename?: 'RequirementStatus', readonly id: number, readonly isFulfilled: boolean, readonly fileUrl?: Maybe<string>, readonly requirement: { readonly __typename?: 'Requirement', readonly id: number, readonly name?: Maybe<string>, readonly description?: Maybe<string>, readonly formDownloadUrl?: Maybe<string> } }> } }> };

export type TeamsByAgeGroupQueryVariables = Exact<{
  ageGroupId: Scalars['Int'];
}>;


export type TeamsByAgeGroupQuery = { readonly __typename?: 'Query', readonly teamsByDivision: ReadonlyArray<{ readonly __typename?: 'Team', readonly id: number, readonly name: string, readonly headCoachName: string, readonly headCoachEmail: string, readonly headCoachCell: string, readonly schedulerName: string, readonly schedulerEmail: string, readonly schedulerCell: string, readonly confirmedGameCount: number, readonly unconfirmedGameCount: number, readonly location?: Maybe<{ readonly __typename?: 'Location', readonly latitude: string, readonly longitude: string }>, readonly division: { readonly __typename?: 'LeagueDivision', readonly id: number, readonly rank: number, readonly modifier?: Maybe<{ readonly __typename?: 'DivisionModifier', readonly id: number, readonly rank: number }> } }> };

export type VerifyPasswordResetTokenQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type VerifyPasswordResetTokenQuery = { readonly __typename?: 'Query', readonly verifyPasswordResetTokenIsValid: boolean };

export type VerifySessionQueryVariables = Exact<{ [key: string]: never; }>;


export type VerifySessionQuery = { readonly __typename?: 'Query', readonly verifySession: boolean };

export const BasicTeamInfoFragmentDoc = gql`
    fragment BasicTeamInfo on Team {
  id
  name
}
    `;
export const AuthenticateDocument = gql`
    mutation Authenticate($usernameOrEmail: String!, $password: String!) {
  authenticate(username: $usernameOrEmail, password: $password) {
    ... on SuccessfulAuthResponse {
      user {
        id
        firstName
        lastName
        email
      }
    }
    ... on FailedAuthResponse {
      message
    }
  }
}
    `;
export type AuthenticateMutationFn = Apollo.MutationFunction<AuthenticateMutation, AuthenticateMutationVariables>;

/**
 * __useAuthenticateMutation__
 *
 * To run a mutation, you first call `useAuthenticateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticateMutation, { data, loading, error }] = useAuthenticateMutation({
 *   variables: {
 *      usernameOrEmail: // value for 'usernameOrEmail'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useAuthenticateMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticateMutation, AuthenticateMutationVariables>) {
        return Apollo.useMutation<AuthenticateMutation, AuthenticateMutationVariables>(AuthenticateDocument, baseOptions);
      }
export type AuthenticateMutationHookResult = ReturnType<typeof useAuthenticateMutation>;
export type AuthenticateMutationResult = Apollo.MutationResult<AuthenticateMutation>;
export type AuthenticateMutationOptions = Apollo.BaseMutationOptions<AuthenticateMutation, AuthenticateMutationVariables>;
export const CompleteAccountCreationDocument = gql`
    mutation CompleteAccountCreation($userId: UUID!, $username: String!, $firstName: String!, $lastName: String!) {
  updateUsername: updateUserUsername(id: $userId, username: $username) {
    id
    username
  }
  updateFirstName: updateUserFirstName(id: $userId, firstName: $firstName) {
    id
    firstName
  }
  updateLastName: updateUserLastName(id: $userId, lastName: $lastName) {
    id
    lastName
  }
}
    `;
export type CompleteAccountCreationMutationFn = Apollo.MutationFunction<CompleteAccountCreationMutation, CompleteAccountCreationMutationVariables>;

/**
 * __useCompleteAccountCreationMutation__
 *
 * To run a mutation, you first call `useCompleteAccountCreationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteAccountCreationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeAccountCreationMutation, { data, loading, error }] = useCompleteAccountCreationMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      username: // value for 'username'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *   },
 * });
 */
export function useCompleteAccountCreationMutation(baseOptions?: Apollo.MutationHookOptions<CompleteAccountCreationMutation, CompleteAccountCreationMutationVariables>) {
        return Apollo.useMutation<CompleteAccountCreationMutation, CompleteAccountCreationMutationVariables>(CompleteAccountCreationDocument, baseOptions);
      }
export type CompleteAccountCreationMutationHookResult = ReturnType<typeof useCompleteAccountCreationMutation>;
export type CompleteAccountCreationMutationResult = Apollo.MutationResult<CompleteAccountCreationMutation>;
export type CompleteAccountCreationMutationOptions = Apollo.BaseMutationOptions<CompleteAccountCreationMutation, CompleteAccountCreationMutationVariables>;
export const CreateAccountDocument = gql`
    mutation CreateAccount($email: String!, $password: String!) {
  createAccount(input: {email: $email, password: $password}) {
    ... on SuccessfulCreateAccountResponse {
      user {
        id
        email
      }
    }
    ... on FailedCreateAccountResponse {
      message
    }
  }
}
    `;
export type CreateAccountMutationFn = Apollo.MutationFunction<CreateAccountMutation, CreateAccountMutationVariables>;

/**
 * __useCreateAccountMutation__
 *
 * To run a mutation, you first call `useCreateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountMutation, { data, loading, error }] = useCreateAccountMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useCreateAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccountMutation, CreateAccountMutationVariables>) {
        return Apollo.useMutation<CreateAccountMutation, CreateAccountMutationVariables>(CreateAccountDocument, baseOptions);
      }
export type CreateAccountMutationHookResult = ReturnType<typeof useCreateAccountMutation>;
export type CreateAccountMutationResult = Apollo.MutationResult<CreateAccountMutation>;
export type CreateAccountMutationOptions = Apollo.BaseMutationOptions<CreateAccountMutation, CreateAccountMutationVariables>;
export const CreateCheckoutForOrdersDocument = gql`
    mutation CreateCheckoutForOrders($orderIds: [Int!]!) {
  createCheckoutSessionForOrderIds(orderIds: $orderIds)
}
    `;
export type CreateCheckoutForOrdersMutationFn = Apollo.MutationFunction<CreateCheckoutForOrdersMutation, CreateCheckoutForOrdersMutationVariables>;

/**
 * __useCreateCheckoutForOrdersMutation__
 *
 * To run a mutation, you first call `useCreateCheckoutForOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCheckoutForOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCheckoutForOrdersMutation, { data, loading, error }] = useCreateCheckoutForOrdersMutation({
 *   variables: {
 *      orderIds: // value for 'orderIds'
 *   },
 * });
 */
export function useCreateCheckoutForOrdersMutation(baseOptions?: Apollo.MutationHookOptions<CreateCheckoutForOrdersMutation, CreateCheckoutForOrdersMutationVariables>) {
        return Apollo.useMutation<CreateCheckoutForOrdersMutation, CreateCheckoutForOrdersMutationVariables>(CreateCheckoutForOrdersDocument, baseOptions);
      }
export type CreateCheckoutForOrdersMutationHookResult = ReturnType<typeof useCreateCheckoutForOrdersMutation>;
export type CreateCheckoutForOrdersMutationResult = Apollo.MutationResult<CreateCheckoutForOrdersMutation>;
export type CreateCheckoutForOrdersMutationOptions = Apollo.BaseMutationOptions<CreateCheckoutForOrdersMutation, CreateCheckoutForOrdersMutationVariables>;
export const CreateRawGameDocument = gql`
    mutation CreateRawGame($enteringTeamId: Int!, $createRawGameData: CreateRawGameInput!) {
  createRawGame(enteringTeamId: $enteringTeamId, data: $createRawGameData) {
    id
    enteringTeam {
      id
      name
    }
    opponentTeam {
      id
      name
    }
    date
    time
    dateTime
    field {
      id
      name
    }
  }
}
    `;
export type CreateRawGameMutationFn = Apollo.MutationFunction<CreateRawGameMutation, CreateRawGameMutationVariables>;

/**
 * __useCreateRawGameMutation__
 *
 * To run a mutation, you first call `useCreateRawGameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRawGameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRawGameMutation, { data, loading, error }] = useCreateRawGameMutation({
 *   variables: {
 *      enteringTeamId: // value for 'enteringTeamId'
 *      createRawGameData: // value for 'createRawGameData'
 *   },
 * });
 */
export function useCreateRawGameMutation(baseOptions?: Apollo.MutationHookOptions<CreateRawGameMutation, CreateRawGameMutationVariables>) {
        return Apollo.useMutation<CreateRawGameMutation, CreateRawGameMutationVariables>(CreateRawGameDocument, baseOptions);
      }
export type CreateRawGameMutationHookResult = ReturnType<typeof useCreateRawGameMutation>;
export type CreateRawGameMutationResult = Apollo.MutationResult<CreateRawGameMutation>;
export type CreateRawGameMutationOptions = Apollo.BaseMutationOptions<CreateRawGameMutation, CreateRawGameMutationVariables>;
export const DeleteRawGameDocument = gql`
    mutation DeleteRawGame($gameId: Int!) {
  updateRawGame {
    delete(gameId: $gameId)
  }
}
    `;
export type DeleteRawGameMutationFn = Apollo.MutationFunction<DeleteRawGameMutation, DeleteRawGameMutationVariables>;

/**
 * __useDeleteRawGameMutation__
 *
 * To run a mutation, you first call `useDeleteRawGameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRawGameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRawGameMutation, { data, loading, error }] = useDeleteRawGameMutation({
 *   variables: {
 *      gameId: // value for 'gameId'
 *   },
 * });
 */
export function useDeleteRawGameMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRawGameMutation, DeleteRawGameMutationVariables>) {
        return Apollo.useMutation<DeleteRawGameMutation, DeleteRawGameMutationVariables>(DeleteRawGameDocument, baseOptions);
      }
export type DeleteRawGameMutationHookResult = ReturnType<typeof useDeleteRawGameMutation>;
export type DeleteRawGameMutationResult = Apollo.MutationResult<DeleteRawGameMutation>;
export type DeleteRawGameMutationOptions = Apollo.BaseMutationOptions<DeleteRawGameMutation, DeleteRawGameMutationVariables>;
export const AddGameForTeamDocument = gql`
    mutation AddGameForTeam($data: CreateGameInput!) {
  createGame(data: $data) {
    id
    homeTeam {
      id
      name
    }
    awayTeam {
      id
      name
    }
    date
    time
    dateTime
    field {
      id
      name
    }
    createdBy {
      id
      name
    }
    isConfirmed
    syncToken
    cancelStatus {
      cancelReason
      rescheduledGame {
        id
      }
    }
  }
}
    `;
export type AddGameForTeamMutationFn = Apollo.MutationFunction<AddGameForTeamMutation, AddGameForTeamMutationVariables>;

/**
 * __useAddGameForTeamMutation__
 *
 * To run a mutation, you first call `useAddGameForTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddGameForTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addGameForTeamMutation, { data, loading, error }] = useAddGameForTeamMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddGameForTeamMutation(baseOptions?: Apollo.MutationHookOptions<AddGameForTeamMutation, AddGameForTeamMutationVariables>) {
        return Apollo.useMutation<AddGameForTeamMutation, AddGameForTeamMutationVariables>(AddGameForTeamDocument, baseOptions);
      }
export type AddGameForTeamMutationHookResult = ReturnType<typeof useAddGameForTeamMutation>;
export type AddGameForTeamMutationResult = Apollo.MutationResult<AddGameForTeamMutation>;
export type AddGameForTeamMutationOptions = Apollo.BaseMutationOptions<AddGameForTeamMutation, AddGameForTeamMutationVariables>;
export const ConfirmGameDocument = gql`
    mutation ConfirmGame($gameId: Int!, $syncToken: String!) {
  confirmGame(gameId: $gameId, syncToken: $syncToken) {
    id
    homeTeam {
      id
      name
    }
    awayTeam {
      id
      name
    }
    date
    time
    dateTime
    field {
      id
      name
    }
    createdBy {
      id
      name
    }
    isConfirmed
    syncToken
    cancelStatus {
      cancelReason
      rescheduledGame {
        id
      }
    }
  }
}
    `;
export type ConfirmGameMutationFn = Apollo.MutationFunction<ConfirmGameMutation, ConfirmGameMutationVariables>;

/**
 * __useConfirmGameMutation__
 *
 * To run a mutation, you first call `useConfirmGameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmGameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmGameMutation, { data, loading, error }] = useConfirmGameMutation({
 *   variables: {
 *      gameId: // value for 'gameId'
 *      syncToken: // value for 'syncToken'
 *   },
 * });
 */
export function useConfirmGameMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmGameMutation, ConfirmGameMutationVariables>) {
        return Apollo.useMutation<ConfirmGameMutation, ConfirmGameMutationVariables>(ConfirmGameDocument, baseOptions);
      }
export type ConfirmGameMutationHookResult = ReturnType<typeof useConfirmGameMutation>;
export type ConfirmGameMutationResult = Apollo.MutationResult<ConfirmGameMutation>;
export type ConfirmGameMutationOptions = Apollo.BaseMutationOptions<ConfirmGameMutation, ConfirmGameMutationVariables>;
export const AddGameDocument = gql`
    mutation AddGame($data: AddGameInput!) {
  addGame(data: $data) {
    id
    createdBy {
      id
      name
    }
    opponent {
      id
      name
    }
    schedulingDetails {
      homeTeam {
        id
        name
      }
      awayTeam {
        id
        name
      }
      dateTime
      field {
        id
        name
      }
    }
  }
}
    `;
export type AddGameMutationFn = Apollo.MutationFunction<AddGameMutation, AddGameMutationVariables>;

/**
 * __useAddGameMutation__
 *
 * To run a mutation, you first call `useAddGameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddGameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addGameMutation, { data, loading, error }] = useAddGameMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddGameMutation(baseOptions?: Apollo.MutationHookOptions<AddGameMutation, AddGameMutationVariables>) {
        return Apollo.useMutation<AddGameMutation, AddGameMutationVariables>(AddGameDocument, baseOptions);
      }
export type AddGameMutationHookResult = ReturnType<typeof useAddGameMutation>;
export type AddGameMutationResult = Apollo.MutationResult<AddGameMutation>;
export type AddGameMutationOptions = Apollo.BaseMutationOptions<AddGameMutation, AddGameMutationVariables>;
export const CancelGameDocument = gql`
    mutation CancelGame($gameId: Int!, $cancellationReason: String) {
  cancelGame(gameId: $gameId, cancellationReason: $cancellationReason) {
    id
    isCancelled
    createdBy {
      id
      name
      displayName: name(format: WITH_DIVISION_AND_MODIFIER)
    }
    opponent {
      id
      name
      displayName: name(format: WITH_DIVISION_AND_MODIFIER)
    }
    schedulingDetails {
      homeTeam {
        id
        name
        displayName: name(format: WITH_DIVISION_AND_MODIFIER)
      }
      awayTeam {
        id
        name
        displayName: name(format: WITH_DIVISION_AND_MODIFIER)
      }
      field {
        id
        name
      }
      dateTime
    }
    formHistory {
      id
      createdBy {
        id
        name
        displayName: name(format: WITH_DIVISION_AND_MODIFIER)
      }
      timeCreated
      approvalStatus
      ... on GameSchedulingForm {
        gameDateTime
        gameField {
          id
          name
        }
        isHomeGameForEnteringTeam
      }
      approvers {
        team {
          id
          name(format: WITH_DIVISION_AND_MODIFIER)
        }
        status
        statusLastUpdated
      }
    }
  }
}
    `;
export type CancelGameMutationFn = Apollo.MutationFunction<CancelGameMutation, CancelGameMutationVariables>;

/**
 * __useCancelGameMutation__
 *
 * To run a mutation, you first call `useCancelGameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelGameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelGameMutation, { data, loading, error }] = useCancelGameMutation({
 *   variables: {
 *      gameId: // value for 'gameId'
 *      cancellationReason: // value for 'cancellationReason'
 *   },
 * });
 */
export function useCancelGameMutation(baseOptions?: Apollo.MutationHookOptions<CancelGameMutation, CancelGameMutationVariables>) {
        return Apollo.useMutation<CancelGameMutation, CancelGameMutationVariables>(CancelGameDocument, baseOptions);
      }
export type CancelGameMutationHookResult = ReturnType<typeof useCancelGameMutation>;
export type CancelGameMutationResult = Apollo.MutationResult<CancelGameMutation>;
export type CancelGameMutationOptions = Apollo.BaseMutationOptions<CancelGameMutation, CancelGameMutationVariables>;
export const CreateGameSchedulingFormForGameDocument = gql`
    mutation CreateGameSchedulingFormForGame($gameId: Int!, $data: GameSchedulingFormInput!, $approvers: [GameFormApprovalInput!]) {
  createGameSchedulingChangeRequest(
    gameId: $gameId
    data: $data
    approvers: $approvers
  ) {
    id
    createdBy {
      id
      name
    }
    opponent {
      id
      name
    }
    schedulingDetails {
      homeTeam {
        id
        name
      }
      awayTeam {
        id
        name
      }
      field {
        id
        name
      }
      dateTime
    }
    formHistory {
      id
      createdBy {
        id
        name
      }
      timeCreated
      approvalStatus
      ... on GameSchedulingForm {
        gameDateTime
        gameField {
          id
          name
        }
        isHomeGameForEnteringTeam
      }
      approvers {
        team {
          id
          name
        }
        status
        statusLastUpdated
      }
    }
  }
}
    `;
export type CreateGameSchedulingFormForGameMutationFn = Apollo.MutationFunction<CreateGameSchedulingFormForGameMutation, CreateGameSchedulingFormForGameMutationVariables>;

/**
 * __useCreateGameSchedulingFormForGameMutation__
 *
 * To run a mutation, you first call `useCreateGameSchedulingFormForGameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGameSchedulingFormForGameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGameSchedulingFormForGameMutation, { data, loading, error }] = useCreateGameSchedulingFormForGameMutation({
 *   variables: {
 *      gameId: // value for 'gameId'
 *      data: // value for 'data'
 *      approvers: // value for 'approvers'
 *   },
 * });
 */
export function useCreateGameSchedulingFormForGameMutation(baseOptions?: Apollo.MutationHookOptions<CreateGameSchedulingFormForGameMutation, CreateGameSchedulingFormForGameMutationVariables>) {
        return Apollo.useMutation<CreateGameSchedulingFormForGameMutation, CreateGameSchedulingFormForGameMutationVariables>(CreateGameSchedulingFormForGameDocument, baseOptions);
      }
export type CreateGameSchedulingFormForGameMutationHookResult = ReturnType<typeof useCreateGameSchedulingFormForGameMutation>;
export type CreateGameSchedulingFormForGameMutationResult = Apollo.MutationResult<CreateGameSchedulingFormForGameMutation>;
export type CreateGameSchedulingFormForGameMutationOptions = Apollo.BaseMutationOptions<CreateGameSchedulingFormForGameMutation, CreateGameSchedulingFormForGameMutationVariables>;
export const UpdateFormApprovalStatusForTeamDocument = gql`
    mutation UpdateFormApprovalStatusForTeam($formId: Int!, $status: String!) {
  updateFormApprovalStatusForTeam(formId: $formId, status: $status) {
    id
    createdBy {
      id
      name
    }
    opponent {
      id
      name
    }
    schedulingDetails {
      homeTeam {
        id
        name
      }
      awayTeam {
        id
        name
      }
      field {
        id
        name
      }
      dateTime
    }
    formHistory {
      id
      createdBy {
        id
        name
      }
      timeCreated
      approvalStatus
      ... on GameSchedulingForm {
        gameDateTime
        gameField {
          id
          name
        }
        isHomeGameForEnteringTeam
      }
      approvers {
        team {
          id
          name
        }
        status
        statusLastUpdated
      }
    }
  }
}
    `;
export type UpdateFormApprovalStatusForTeamMutationFn = Apollo.MutationFunction<UpdateFormApprovalStatusForTeamMutation, UpdateFormApprovalStatusForTeamMutationVariables>;

/**
 * __useUpdateFormApprovalStatusForTeamMutation__
 *
 * To run a mutation, you first call `useUpdateFormApprovalStatusForTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFormApprovalStatusForTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFormApprovalStatusForTeamMutation, { data, loading, error }] = useUpdateFormApprovalStatusForTeamMutation({
 *   variables: {
 *      formId: // value for 'formId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateFormApprovalStatusForTeamMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFormApprovalStatusForTeamMutation, UpdateFormApprovalStatusForTeamMutationVariables>) {
        return Apollo.useMutation<UpdateFormApprovalStatusForTeamMutation, UpdateFormApprovalStatusForTeamMutationVariables>(UpdateFormApprovalStatusForTeamDocument, baseOptions);
      }
export type UpdateFormApprovalStatusForTeamMutationHookResult = ReturnType<typeof useUpdateFormApprovalStatusForTeamMutation>;
export type UpdateFormApprovalStatusForTeamMutationResult = Apollo.MutationResult<UpdateFormApprovalStatusForTeamMutation>;
export type UpdateFormApprovalStatusForTeamMutationOptions = Apollo.BaseMutationOptions<UpdateFormApprovalStatusForTeamMutation, UpdateFormApprovalStatusForTeamMutationVariables>;
export const RejectGameDocument = gql`
    mutation RejectGame($gameId: Int!, $syncToken: String!) {
  rejectGame(gameId: $gameId, syncToken: $syncToken) {
    id
    homeTeam {
      id
      name
    }
    awayTeam {
      id
      name
    }
    date
    time
    dateTime
    field {
      id
      name
    }
    createdBy {
      id
      name
    }
    isConfirmed
    syncToken
    cancelStatus {
      cancelReason
      rescheduledGame {
        id
      }
    }
  }
}
    `;
export type RejectGameMutationFn = Apollo.MutationFunction<RejectGameMutation, RejectGameMutationVariables>;

/**
 * __useRejectGameMutation__
 *
 * To run a mutation, you first call `useRejectGameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectGameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectGameMutation, { data, loading, error }] = useRejectGameMutation({
 *   variables: {
 *      gameId: // value for 'gameId'
 *      syncToken: // value for 'syncToken'
 *   },
 * });
 */
export function useRejectGameMutation(baseOptions?: Apollo.MutationHookOptions<RejectGameMutation, RejectGameMutationVariables>) {
        return Apollo.useMutation<RejectGameMutation, RejectGameMutationVariables>(RejectGameDocument, baseOptions);
      }
export type RejectGameMutationHookResult = ReturnType<typeof useRejectGameMutation>;
export type RejectGameMutationResult = Apollo.MutationResult<RejectGameMutation>;
export type RejectGameMutationOptions = Apollo.BaseMutationOptions<RejectGameMutation, RejectGameMutationVariables>;
export const LogoutDocument = gql`
    mutation Logout {
  logout
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, baseOptions);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const PlaceOrderForTeamDocument = gql`
    mutation PlaceOrderForTeam($data: CreateOrderInput!) {
  createOrder(input: $data) {
    success
    order {
      id
      didReceivePayment
      paymentNotes
      quantity
      totalCost {
        amount
      }
      productDetails {
        id
        name
        unitPrice {
          amount
          currencyCode
        }
      }
    }
  }
}
    `;
export type PlaceOrderForTeamMutationFn = Apollo.MutationFunction<PlaceOrderForTeamMutation, PlaceOrderForTeamMutationVariables>;

/**
 * __usePlaceOrderForTeamMutation__
 *
 * To run a mutation, you first call `usePlaceOrderForTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePlaceOrderForTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [placeOrderForTeamMutation, { data, loading, error }] = usePlaceOrderForTeamMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function usePlaceOrderForTeamMutation(baseOptions?: Apollo.MutationHookOptions<PlaceOrderForTeamMutation, PlaceOrderForTeamMutationVariables>) {
        return Apollo.useMutation<PlaceOrderForTeamMutation, PlaceOrderForTeamMutationVariables>(PlaceOrderForTeamDocument, baseOptions);
      }
export type PlaceOrderForTeamMutationHookResult = ReturnType<typeof usePlaceOrderForTeamMutation>;
export type PlaceOrderForTeamMutationResult = Apollo.MutationResult<PlaceOrderForTeamMutation>;
export type PlaceOrderForTeamMutationOptions = Apollo.BaseMutationOptions<PlaceOrderForTeamMutation, PlaceOrderForTeamMutationVariables>;
export const RequestPasswordResetDocument = gql`
    mutation RequestPasswordReset($emailOrUsername: String!) {
  requestPasswordReset(email: $emailOrUsername)
}
    `;
export type RequestPasswordResetMutationFn = Apollo.MutationFunction<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>;

/**
 * __useRequestPasswordResetMutation__
 *
 * To run a mutation, you first call `useRequestPasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPasswordResetMutation, { data, loading, error }] = useRequestPasswordResetMutation({
 *   variables: {
 *      emailOrUsername: // value for 'emailOrUsername'
 *   },
 * });
 */
export function useRequestPasswordResetMutation(baseOptions?: Apollo.MutationHookOptions<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>) {
        return Apollo.useMutation<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>(RequestPasswordResetDocument, baseOptions);
      }
export type RequestPasswordResetMutationHookResult = ReturnType<typeof useRequestPasswordResetMutation>;
export type RequestPasswordResetMutationResult = Apollo.MutationResult<RequestPasswordResetMutation>;
export type RequestPasswordResetMutationOptions = Apollo.BaseMutationOptions<RequestPasswordResetMutation, RequestPasswordResetMutationVariables>;
export const ResendPortalUrlsDocument = gql`
    mutation ResendPortalUrls($email: String!) {
  sendPortalLinks(email: $email)
}
    `;
export type ResendPortalUrlsMutationFn = Apollo.MutationFunction<ResendPortalUrlsMutation, ResendPortalUrlsMutationVariables>;

/**
 * __useResendPortalUrlsMutation__
 *
 * To run a mutation, you first call `useResendPortalUrlsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendPortalUrlsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendPortalUrlsMutation, { data, loading, error }] = useResendPortalUrlsMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResendPortalUrlsMutation(baseOptions?: Apollo.MutationHookOptions<ResendPortalUrlsMutation, ResendPortalUrlsMutationVariables>) {
        return Apollo.useMutation<ResendPortalUrlsMutation, ResendPortalUrlsMutationVariables>(ResendPortalUrlsDocument, baseOptions);
      }
export type ResendPortalUrlsMutationHookResult = ReturnType<typeof useResendPortalUrlsMutation>;
export type ResendPortalUrlsMutationResult = Apollo.MutationResult<ResendPortalUrlsMutation>;
export type ResendPortalUrlsMutationOptions = Apollo.BaseMutationOptions<ResendPortalUrlsMutation, ResendPortalUrlsMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($token: String!, $password: String!) {
  resetPassword(token: $token, password: $password)
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      token: // value for 'token'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, baseOptions);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const SetIsCommittedToPlayoffsDocument = gql`
    mutation SetIsCommittedToPlayoffs($teamId: Int!, $status: Boolean!) {
  updateTeam {
    setIsCommittedToPlayoffs(id: $teamId, status: $status) {
      id
      isCommittedToPlayoffs
    }
  }
}
    `;
export type SetIsCommittedToPlayoffsMutationFn = Apollo.MutationFunction<SetIsCommittedToPlayoffsMutation, SetIsCommittedToPlayoffsMutationVariables>;

/**
 * __useSetIsCommittedToPlayoffsMutation__
 *
 * To run a mutation, you first call `useSetIsCommittedToPlayoffsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetIsCommittedToPlayoffsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setIsCommittedToPlayoffsMutation, { data, loading, error }] = useSetIsCommittedToPlayoffsMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useSetIsCommittedToPlayoffsMutation(baseOptions?: Apollo.MutationHookOptions<SetIsCommittedToPlayoffsMutation, SetIsCommittedToPlayoffsMutationVariables>) {
        return Apollo.useMutation<SetIsCommittedToPlayoffsMutation, SetIsCommittedToPlayoffsMutationVariables>(SetIsCommittedToPlayoffsDocument, baseOptions);
      }
export type SetIsCommittedToPlayoffsMutationHookResult = ReturnType<typeof useSetIsCommittedToPlayoffsMutation>;
export type SetIsCommittedToPlayoffsMutationResult = Apollo.MutationResult<SetIsCommittedToPlayoffsMutation>;
export type SetIsCommittedToPlayoffsMutationOptions = Apollo.BaseMutationOptions<SetIsCommittedToPlayoffsMutation, SetIsCommittedToPlayoffsMutationVariables>;
export const UpdateOrderFulfilmentStatusDocument = gql`
    mutation UpdateOrderFulfilmentStatus($orderId: Int!, $status: Boolean!) {
  updateOrderFulfilmentStatus(orderId: $orderId, status: $status) {
    id
    wasFulfilled
  }
}
    `;
export type UpdateOrderFulfilmentStatusMutationFn = Apollo.MutationFunction<UpdateOrderFulfilmentStatusMutation, UpdateOrderFulfilmentStatusMutationVariables>;

/**
 * __useUpdateOrderFulfilmentStatusMutation__
 *
 * To run a mutation, you first call `useUpdateOrderFulfilmentStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderFulfilmentStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderFulfilmentStatusMutation, { data, loading, error }] = useUpdateOrderFulfilmentStatusMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateOrderFulfilmentStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderFulfilmentStatusMutation, UpdateOrderFulfilmentStatusMutationVariables>) {
        return Apollo.useMutation<UpdateOrderFulfilmentStatusMutation, UpdateOrderFulfilmentStatusMutationVariables>(UpdateOrderFulfilmentStatusDocument, baseOptions);
      }
export type UpdateOrderFulfilmentStatusMutationHookResult = ReturnType<typeof useUpdateOrderFulfilmentStatusMutation>;
export type UpdateOrderFulfilmentStatusMutationResult = Apollo.MutationResult<UpdateOrderFulfilmentStatusMutation>;
export type UpdateOrderFulfilmentStatusMutationOptions = Apollo.BaseMutationOptions<UpdateOrderFulfilmentStatusMutation, UpdateOrderFulfilmentStatusMutationVariables>;
export const UpdateOrderPaymentStatusDocument = gql`
    mutation UpdateOrderPaymentStatus($orderId: Int!, $paymentStatus: Boolean!, $paymentNotes: String) {
  updateOrderPaymentStatus(
    orderId: $orderId
    paymentStatus: $paymentStatus
    paymentNotes: $paymentNotes
  ) {
    order {
      id
      didReceivePayment
      paymentNotes
    }
  }
}
    `;
export type UpdateOrderPaymentStatusMutationFn = Apollo.MutationFunction<UpdateOrderPaymentStatusMutation, UpdateOrderPaymentStatusMutationVariables>;

/**
 * __useUpdateOrderPaymentStatusMutation__
 *
 * To run a mutation, you first call `useUpdateOrderPaymentStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderPaymentStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderPaymentStatusMutation, { data, loading, error }] = useUpdateOrderPaymentStatusMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      paymentStatus: // value for 'paymentStatus'
 *      paymentNotes: // value for 'paymentNotes'
 *   },
 * });
 */
export function useUpdateOrderPaymentStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderPaymentStatusMutation, UpdateOrderPaymentStatusMutationVariables>) {
        return Apollo.useMutation<UpdateOrderPaymentStatusMutation, UpdateOrderPaymentStatusMutationVariables>(UpdateOrderPaymentStatusDocument, baseOptions);
      }
export type UpdateOrderPaymentStatusMutationHookResult = ReturnType<typeof useUpdateOrderPaymentStatusMutation>;
export type UpdateOrderPaymentStatusMutationResult = Apollo.MutationResult<UpdateOrderPaymentStatusMutation>;
export type UpdateOrderPaymentStatusMutationOptions = Apollo.BaseMutationOptions<UpdateOrderPaymentStatusMutation, UpdateOrderPaymentStatusMutationVariables>;
export const UpdateOrderQuantityDocument = gql`
    mutation UpdateOrderQuantity($orderId: Int!, $quantity: Int!) {
  updateOrderQuantity(orderId: $orderId, quantity: $quantity) {
    id
    didReceivePayment
    paymentNotes
    quantity
    totalCost {
      amount
    }
    productDetails {
      id
      name
      unitPrice {
        amount
        currencyCode
      }
    }
  }
}
    `;
export type UpdateOrderQuantityMutationFn = Apollo.MutationFunction<UpdateOrderQuantityMutation, UpdateOrderQuantityMutationVariables>;

/**
 * __useUpdateOrderQuantityMutation__
 *
 * To run a mutation, you first call `useUpdateOrderQuantityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderQuantityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderQuantityMutation, { data, loading, error }] = useUpdateOrderQuantityMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      quantity: // value for 'quantity'
 *   },
 * });
 */
export function useUpdateOrderQuantityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderQuantityMutation, UpdateOrderQuantityMutationVariables>) {
        return Apollo.useMutation<UpdateOrderQuantityMutation, UpdateOrderQuantityMutationVariables>(UpdateOrderQuantityDocument, baseOptions);
      }
export type UpdateOrderQuantityMutationHookResult = ReturnType<typeof useUpdateOrderQuantityMutation>;
export type UpdateOrderQuantityMutationResult = Apollo.MutationResult<UpdateOrderQuantityMutation>;
export type UpdateOrderQuantityMutationOptions = Apollo.BaseMutationOptions<UpdateOrderQuantityMutation, UpdateOrderQuantityMutationVariables>;
export const UpdateRawGameDocument = gql`
    mutation UpdateRawGame($gameId: Int!, $data: CreateRawGameInput!) {
  updateRawGame {
    update(gameId: $gameId, data: $data) {
      id
      enteringTeam {
        id
        name
      }
      opponentTeam {
        id
        name
      }
      date
      time
      dateTime
      field {
        id
        name
      }
    }
  }
}
    `;
export type UpdateRawGameMutationFn = Apollo.MutationFunction<UpdateRawGameMutation, UpdateRawGameMutationVariables>;

/**
 * __useUpdateRawGameMutation__
 *
 * To run a mutation, you first call `useUpdateRawGameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRawGameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRawGameMutation, { data, loading, error }] = useUpdateRawGameMutation({
 *   variables: {
 *      gameId: // value for 'gameId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateRawGameMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRawGameMutation, UpdateRawGameMutationVariables>) {
        return Apollo.useMutation<UpdateRawGameMutation, UpdateRawGameMutationVariables>(UpdateRawGameDocument, baseOptions);
      }
export type UpdateRawGameMutationHookResult = ReturnType<typeof useUpdateRawGameMutation>;
export type UpdateRawGameMutationResult = Apollo.MutationResult<UpdateRawGameMutation>;
export type UpdateRawGameMutationOptions = Apollo.BaseMutationOptions<UpdateRawGameMutation, UpdateRawGameMutationVariables>;
export const UpdateTeamRequirementStatusDocument = gql`
    mutation UpdateTeamRequirementStatus($teamId: Int!, $requirementId: Int!, $status: Boolean!, $fileId: String) {
  updateRequirements {
    setRequirementStatus(
      teamId: $teamId
      requirementId: $requirementId
      status: $status
      fileId: $fileId
    ) {
      id
      isFulfilled
      fileUrl
    }
  }
}
    `;
export type UpdateTeamRequirementStatusMutationFn = Apollo.MutationFunction<UpdateTeamRequirementStatusMutation, UpdateTeamRequirementStatusMutationVariables>;

/**
 * __useUpdateTeamRequirementStatusMutation__
 *
 * To run a mutation, you first call `useUpdateTeamRequirementStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamRequirementStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamRequirementStatusMutation, { data, loading, error }] = useUpdateTeamRequirementStatusMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      requirementId: // value for 'requirementId'
 *      status: // value for 'status'
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useUpdateTeamRequirementStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTeamRequirementStatusMutation, UpdateTeamRequirementStatusMutationVariables>) {
        return Apollo.useMutation<UpdateTeamRequirementStatusMutation, UpdateTeamRequirementStatusMutationVariables>(UpdateTeamRequirementStatusDocument, baseOptions);
      }
export type UpdateTeamRequirementStatusMutationHookResult = ReturnType<typeof useUpdateTeamRequirementStatusMutation>;
export type UpdateTeamRequirementStatusMutationResult = Apollo.MutationResult<UpdateTeamRequirementStatusMutation>;
export type UpdateTeamRequirementStatusMutationOptions = Apollo.BaseMutationOptions<UpdateTeamRequirementStatusMutation, UpdateTeamRequirementStatusMutationVariables>;
export const VerifyEmailDocument = gql`
    mutation VerifyEmail($token: String!) {
  verifyEmailAddress(verificationText: $token)
}
    `;
export type VerifyEmailMutationFn = Apollo.MutationFunction<VerifyEmailMutation, VerifyEmailMutationVariables>;

/**
 * __useVerifyEmailMutation__
 *
 * To run a mutation, you first call `useVerifyEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyEmailMutation, { data, loading, error }] = useVerifyEmailMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useVerifyEmailMutation(baseOptions?: Apollo.MutationHookOptions<VerifyEmailMutation, VerifyEmailMutationVariables>) {
        return Apollo.useMutation<VerifyEmailMutation, VerifyEmailMutationVariables>(VerifyEmailDocument, baseOptions);
      }
export type VerifyEmailMutationHookResult = ReturnType<typeof useVerifyEmailMutation>;
export type VerifyEmailMutationResult = Apollo.MutationResult<VerifyEmailMutation>;
export type VerifyEmailMutationOptions = Apollo.BaseMutationOptions<VerifyEmailMutation, VerifyEmailMutationVariables>;
export const AllFieldsDocument = gql`
    query AllFields {
  fields {
    id
    name
  }
}
    `;

/**
 * __useAllFieldsQuery__
 *
 * To run a query within a React component, call `useAllFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllFieldsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllFieldsQuery(baseOptions?: Apollo.QueryHookOptions<AllFieldsQuery, AllFieldsQueryVariables>) {
        return Apollo.useQuery<AllFieldsQuery, AllFieldsQueryVariables>(AllFieldsDocument, baseOptions);
      }
export function useAllFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllFieldsQuery, AllFieldsQueryVariables>) {
          return Apollo.useLazyQuery<AllFieldsQuery, AllFieldsQueryVariables>(AllFieldsDocument, baseOptions);
        }
export type AllFieldsQueryHookResult = ReturnType<typeof useAllFieldsQuery>;
export type AllFieldsLazyQueryHookResult = ReturnType<typeof useAllFieldsLazyQuery>;
export type AllFieldsQueryResult = Apollo.QueryResult<AllFieldsQuery, AllFieldsQueryVariables>;
export const AllTeamsDocument = gql`
    query AllTeams {
  teams(first: 1000) {
    id
    name(format: WITH_DIVISION_AND_MODIFIER)
    division {
      id
      rank
      modifier {
        id
        rank
      }
    }
    location {
      latitude
      longitude
    }
  }
}
    `;

/**
 * __useAllTeamsQuery__
 *
 * To run a query within a React component, call `useAllTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTeamsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllTeamsQuery(baseOptions?: Apollo.QueryHookOptions<AllTeamsQuery, AllTeamsQueryVariables>) {
        return Apollo.useQuery<AllTeamsQuery, AllTeamsQueryVariables>(AllTeamsDocument, baseOptions);
      }
export function useAllTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllTeamsQuery, AllTeamsQueryVariables>) {
          return Apollo.useLazyQuery<AllTeamsQuery, AllTeamsQueryVariables>(AllTeamsDocument, baseOptions);
        }
export type AllTeamsQueryHookResult = ReturnType<typeof useAllTeamsQuery>;
export type AllTeamsLazyQueryHookResult = ReturnType<typeof useAllTeamsLazyQuery>;
export type AllTeamsQueryResult = Apollo.QueryResult<AllTeamsQuery, AllTeamsQueryVariables>;
export const AllTeamsInSeasonDocument = gql`
    query AllTeamsInSeason($viewingTeamId: Int!) {
  teamsInSameSeason(viewingTeamId: $viewingTeamId) {
    id
    name(format: WITH_DIVISION_AND_MODIFIER)
    division {
      id
      rank
      modifier {
        id
        rank
      }
    }
    location {
      latitude
      longitude
    }
  }
}
    `;

/**
 * __useAllTeamsInSeasonQuery__
 *
 * To run a query within a React component, call `useAllTeamsInSeasonQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTeamsInSeasonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTeamsInSeasonQuery({
 *   variables: {
 *      viewingTeamId: // value for 'viewingTeamId'
 *   },
 * });
 */
export function useAllTeamsInSeasonQuery(baseOptions: Apollo.QueryHookOptions<AllTeamsInSeasonQuery, AllTeamsInSeasonQueryVariables>) {
        return Apollo.useQuery<AllTeamsInSeasonQuery, AllTeamsInSeasonQueryVariables>(AllTeamsInSeasonDocument, baseOptions);
      }
export function useAllTeamsInSeasonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllTeamsInSeasonQuery, AllTeamsInSeasonQueryVariables>) {
          return Apollo.useLazyQuery<AllTeamsInSeasonQuery, AllTeamsInSeasonQueryVariables>(AllTeamsInSeasonDocument, baseOptions);
        }
export type AllTeamsInSeasonQueryHookResult = ReturnType<typeof useAllTeamsInSeasonQuery>;
export type AllTeamsInSeasonLazyQueryHookResult = ReturnType<typeof useAllTeamsInSeasonLazyQuery>;
export type AllTeamsInSeasonQueryResult = Apollo.QueryResult<AllTeamsInSeasonQuery, AllTeamsInSeasonQueryVariables>;
export const AmIAdminDocument = gql`
    query AmIAdmin {
  amIAdmin
}
    `;

/**
 * __useAmIAdminQuery__
 *
 * To run a query within a React component, call `useAmIAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmIAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmIAdminQuery({
 *   variables: {
 *   },
 * });
 */
export function useAmIAdminQuery(baseOptions?: Apollo.QueryHookOptions<AmIAdminQuery, AmIAdminQueryVariables>) {
        return Apollo.useQuery<AmIAdminQuery, AmIAdminQueryVariables>(AmIAdminDocument, baseOptions);
      }
export function useAmIAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmIAdminQuery, AmIAdminQueryVariables>) {
          return Apollo.useLazyQuery<AmIAdminQuery, AmIAdminQueryVariables>(AmIAdminDocument, baseOptions);
        }
export type AmIAdminQueryHookResult = ReturnType<typeof useAmIAdminQuery>;
export type AmIAdminLazyQueryHookResult = ReturnType<typeof useAmIAdminLazyQuery>;
export type AmIAdminQueryResult = Apollo.QueryResult<AmIAdminQuery, AmIAdminQueryVariables>;
export const GameFormByIdDocument = gql`
    query GameFormById($formId: Int!) {
  formById(id: $formId) {
    id
    createdBy {
      id
      name
      displayName: name(format: WITH_DIVISION_AND_MODIFIER)
    }
    timeCreated
    approvalStatus
    ... on GameSchedulingForm {
      gameDateTime
      gameField {
        id
        name
      }
      isHomeGameForEnteringTeam
    }
    approvers {
      team {
        id
        name(format: WITH_DIVISION_AND_MODIFIER)
      }
      status
      statusLastUpdated
    }
  }
}
    `;

/**
 * __useGameFormByIdQuery__
 *
 * To run a query within a React component, call `useGameFormByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGameFormByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGameFormByIdQuery({
 *   variables: {
 *      formId: // value for 'formId'
 *   },
 * });
 */
export function useGameFormByIdQuery(baseOptions: Apollo.QueryHookOptions<GameFormByIdQuery, GameFormByIdQueryVariables>) {
        return Apollo.useQuery<GameFormByIdQuery, GameFormByIdQueryVariables>(GameFormByIdDocument, baseOptions);
      }
export function useGameFormByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GameFormByIdQuery, GameFormByIdQueryVariables>) {
          return Apollo.useLazyQuery<GameFormByIdQuery, GameFormByIdQueryVariables>(GameFormByIdDocument, baseOptions);
        }
export type GameFormByIdQueryHookResult = ReturnType<typeof useGameFormByIdQuery>;
export type GameFormByIdLazyQueryHookResult = ReturnType<typeof useGameFormByIdLazyQuery>;
export type GameFormByIdQueryResult = Apollo.QueryResult<GameFormByIdQuery, GameFormByIdQueryVariables>;
export const GamesByTeamDocument = gql`
    query GamesByTeam($teamId: Int!) {
  gamesForTeam(id: $teamId) {
    id
    isCancelled
    primaryUmpire {
      firstName
      lastName
      phoneNumber
    }
    secondaryUmpire {
      firstName
      lastName
      phoneNumber
    }
    createdBy {
      id
      name
      displayName: name(format: WITH_DIVISION_AND_MODIFIER)
    }
    opponent {
      id
      name
      displayName: name(format: WITH_DIVISION_AND_MODIFIER)
    }
    schedulingDetails {
      homeTeam {
        id
        name
        displayName: name(format: WITH_DIVISION_AND_MODIFIER)
      }
      awayTeam {
        id
        name
        displayName: name(format: WITH_DIVISION_AND_MODIFIER)
      }
      field {
        id
        name
      }
      dateTime
    }
    formHistory {
      id
      createdBy {
        id
        name
        displayName: name(format: WITH_DIVISION_AND_MODIFIER)
      }
      timeCreated
      approvalStatus
      ... on GameSchedulingForm {
        gameDateTime
        gameField {
          id
          name
        }
        isHomeGameForEnteringTeam
      }
      approvers {
        team {
          id
          name(format: WITH_DIVISION_AND_MODIFIER)
        }
        status
        statusLastUpdated
      }
    }
  }
}
    `;

/**
 * __useGamesByTeamQuery__
 *
 * To run a query within a React component, call `useGamesByTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGamesByTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGamesByTeamQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useGamesByTeamQuery(baseOptions: Apollo.QueryHookOptions<GamesByTeamQuery, GamesByTeamQueryVariables>) {
        return Apollo.useQuery<GamesByTeamQuery, GamesByTeamQueryVariables>(GamesByTeamDocument, baseOptions);
      }
export function useGamesByTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GamesByTeamQuery, GamesByTeamQueryVariables>) {
          return Apollo.useLazyQuery<GamesByTeamQuery, GamesByTeamQueryVariables>(GamesByTeamDocument, baseOptions);
        }
export type GamesByTeamQueryHookResult = ReturnType<typeof useGamesByTeamQuery>;
export type GamesByTeamLazyQueryHookResult = ReturnType<typeof useGamesByTeamLazyQuery>;
export type GamesByTeamQueryResult = Apollo.QueryResult<GamesByTeamQuery, GamesByTeamQueryVariables>;
export const GamesForTeamDocument = gql`
    query GamesForTeam($teamId: Int!) {
  gamesByTeam(teamId: $teamId) {
    id
    homeTeam {
      id
      name
    }
    awayTeam {
      id
      name
    }
    date
    time
    dateTime
    field {
      id
      name
    }
    createdBy {
      id
      name
    }
    isConfirmed
    syncToken
    cancelStatus {
      cancelReason
      rescheduledGame {
        id
      }
    }
  }
}
    `;

/**
 * __useGamesForTeamQuery__
 *
 * To run a query within a React component, call `useGamesForTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useGamesForTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGamesForTeamQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useGamesForTeamQuery(baseOptions: Apollo.QueryHookOptions<GamesForTeamQuery, GamesForTeamQueryVariables>) {
        return Apollo.useQuery<GamesForTeamQuery, GamesForTeamQueryVariables>(GamesForTeamDocument, baseOptions);
      }
export function useGamesForTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GamesForTeamQuery, GamesForTeamQueryVariables>) {
          return Apollo.useLazyQuery<GamesForTeamQuery, GamesForTeamQueryVariables>(GamesForTeamDocument, baseOptions);
        }
export type GamesForTeamQueryHookResult = ReturnType<typeof useGamesForTeamQuery>;
export type GamesForTeamLazyQueryHookResult = ReturnType<typeof useGamesForTeamLazyQuery>;
export type GamesForTeamQueryResult = Apollo.QueryResult<GamesForTeamQuery, GamesForTeamQueryVariables>;
export const MeDocument = gql`
    query Me {
  me {
    id
    firstName
    lastName
    username
    email
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, baseOptions);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, baseOptions);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const OrdersForTeamDocument = gql`
    query OrdersForTeam($teamId: Int!) {
  team(id: $teamId) {
    financials {
      outstandingBalance {
        amount
      }
      orders {
        id
        didReceivePayment
        paymentNotes
        quantity
        wasFulfilled
        totalCost {
          amount
        }
        productDetails {
          id
          name
          unitPrice {
            amount
            currencyCode
          }
        }
      }
    }
  }
}
    `;

/**
 * __useOrdersForTeamQuery__
 *
 * To run a query within a React component, call `useOrdersForTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdersForTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdersForTeamQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useOrdersForTeamQuery(baseOptions: Apollo.QueryHookOptions<OrdersForTeamQuery, OrdersForTeamQueryVariables>) {
        return Apollo.useQuery<OrdersForTeamQuery, OrdersForTeamQueryVariables>(OrdersForTeamDocument, baseOptions);
      }
export function useOrdersForTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrdersForTeamQuery, OrdersForTeamQueryVariables>) {
          return Apollo.useLazyQuery<OrdersForTeamQuery, OrdersForTeamQueryVariables>(OrdersForTeamDocument, baseOptions);
        }
export type OrdersForTeamQueryHookResult = ReturnType<typeof useOrdersForTeamQuery>;
export type OrdersForTeamLazyQueryHookResult = ReturnType<typeof useOrdersForTeamLazyQuery>;
export type OrdersForTeamQueryResult = Apollo.QueryResult<OrdersForTeamQuery, OrdersForTeamQueryVariables>;
export const PortalHomeContentDocument = gql`
    query PortalHomeContent {
  portalHomeContent
}
    `;

/**
 * __usePortalHomeContentQuery__
 *
 * To run a query within a React component, call `usePortalHomeContentQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortalHomeContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortalHomeContentQuery({
 *   variables: {
 *   },
 * });
 */
export function usePortalHomeContentQuery(baseOptions?: Apollo.QueryHookOptions<PortalHomeContentQuery, PortalHomeContentQueryVariables>) {
        return Apollo.useQuery<PortalHomeContentQuery, PortalHomeContentQueryVariables>(PortalHomeContentDocument, baseOptions);
      }
export function usePortalHomeContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PortalHomeContentQuery, PortalHomeContentQueryVariables>) {
          return Apollo.useLazyQuery<PortalHomeContentQuery, PortalHomeContentQueryVariables>(PortalHomeContentDocument, baseOptions);
        }
export type PortalHomeContentQueryHookResult = ReturnType<typeof usePortalHomeContentQuery>;
export type PortalHomeContentLazyQueryHookResult = ReturnType<typeof usePortalHomeContentLazyQuery>;
export type PortalHomeContentQueryResult = Apollo.QueryResult<PortalHomeContentQuery, PortalHomeContentQueryVariables>;
export const RawGamesForTeamDocument = gql`
    query RawGamesForTeam($teamId: Int!) {
  rawGames(enteringTeamId: $teamId) {
    id
    enteringTeam {
      id
      name
    }
    opponentTeam {
      id
      name
    }
    field {
      id
      name
    }
    date
    time
    dateTime
    isHomeGameForEnteringTeam
  }
}
    `;

/**
 * __useRawGamesForTeamQuery__
 *
 * To run a query within a React component, call `useRawGamesForTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useRawGamesForTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRawGamesForTeamQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useRawGamesForTeamQuery(baseOptions: Apollo.QueryHookOptions<RawGamesForTeamQuery, RawGamesForTeamQueryVariables>) {
        return Apollo.useQuery<RawGamesForTeamQuery, RawGamesForTeamQueryVariables>(RawGamesForTeamDocument, baseOptions);
      }
export function useRawGamesForTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RawGamesForTeamQuery, RawGamesForTeamQueryVariables>) {
          return Apollo.useLazyQuery<RawGamesForTeamQuery, RawGamesForTeamQueryVariables>(RawGamesForTeamDocument, baseOptions);
        }
export type RawGamesForTeamQueryHookResult = ReturnType<typeof useRawGamesForTeamQuery>;
export type RawGamesForTeamLazyQueryHookResult = ReturnType<typeof useRawGamesForTeamLazyQuery>;
export type RawGamesForTeamQueryResult = Apollo.QueryResult<RawGamesForTeamQuery, RawGamesForTeamQueryVariables>;
export const TeamByGuidDocument = gql`
    query TeamByGuid($guid: UUID!) {
  team: teamByGUID(guid: $guid) {
    id
    name
    displayName: name(format: WITH_DIVISION_AND_MODIFIER)
    headCoachName
    isCommittedToPlayoffs
    division {
      id
      rank
      name
      group {
        id
      }
      modifier {
        id
        rank
      }
      season {
        id
        name
      }
    }
    location {
      latitude
      longitude
    }
  }
}
    `;

/**
 * __useTeamByGuidQuery__
 *
 * To run a query within a React component, call `useTeamByGuidQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamByGuidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamByGuidQuery({
 *   variables: {
 *      guid: // value for 'guid'
 *   },
 * });
 */
export function useTeamByGuidQuery(baseOptions: Apollo.QueryHookOptions<TeamByGuidQuery, TeamByGuidQueryVariables>) {
        return Apollo.useQuery<TeamByGuidQuery, TeamByGuidQueryVariables>(TeamByGuidDocument, baseOptions);
      }
export function useTeamByGuidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamByGuidQuery, TeamByGuidQueryVariables>) {
          return Apollo.useLazyQuery<TeamByGuidQuery, TeamByGuidQueryVariables>(TeamByGuidDocument, baseOptions);
        }
export type TeamByGuidQueryHookResult = ReturnType<typeof useTeamByGuidQuery>;
export type TeamByGuidLazyQueryHookResult = ReturnType<typeof useTeamByGuidLazyQuery>;
export type TeamByGuidQueryResult = Apollo.QueryResult<TeamByGuidQuery, TeamByGuidQueryVariables>;
export const TeamRequirementsDocument = gql`
    query TeamRequirements($teamId: Int!) {
  team(id: $teamId) {
    requirementStatus {
      inGoodStanding
      requirementStatuses {
        id
        requirement {
          id
          name
          description
          formDownloadUrl
        }
        isFulfilled
        fileUrl
      }
    }
  }
}
    `;

/**
 * __useTeamRequirementsQuery__
 *
 * To run a query within a React component, call `useTeamRequirementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamRequirementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamRequirementsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useTeamRequirementsQuery(baseOptions: Apollo.QueryHookOptions<TeamRequirementsQuery, TeamRequirementsQueryVariables>) {
        return Apollo.useQuery<TeamRequirementsQuery, TeamRequirementsQueryVariables>(TeamRequirementsDocument, baseOptions);
      }
export function useTeamRequirementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamRequirementsQuery, TeamRequirementsQueryVariables>) {
          return Apollo.useLazyQuery<TeamRequirementsQuery, TeamRequirementsQueryVariables>(TeamRequirementsDocument, baseOptions);
        }
export type TeamRequirementsQueryHookResult = ReturnType<typeof useTeamRequirementsQuery>;
export type TeamRequirementsLazyQueryHookResult = ReturnType<typeof useTeamRequirementsLazyQuery>;
export type TeamRequirementsQueryResult = Apollo.QueryResult<TeamRequirementsQuery, TeamRequirementsQueryVariables>;
export const TeamsByAgeGroupDocument = gql`
    query TeamsByAgeGroup($ageGroupId: Int!) {
  teamsByDivision(divisionId: $ageGroupId) {
    id
    name(format: WITH_DIVISION_AND_MODIFIER)
    headCoachName
    headCoachEmail
    headCoachCell
    schedulerName
    schedulerEmail
    schedulerCell
    confirmedGameCount
    unconfirmedGameCount
    location {
      latitude
      longitude
    }
    division {
      id
      rank
      modifier {
        id
        rank
      }
    }
  }
}
    `;

/**
 * __useTeamsByAgeGroupQuery__
 *
 * To run a query within a React component, call `useTeamsByAgeGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamsByAgeGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamsByAgeGroupQuery({
 *   variables: {
 *      ageGroupId: // value for 'ageGroupId'
 *   },
 * });
 */
export function useTeamsByAgeGroupQuery(baseOptions: Apollo.QueryHookOptions<TeamsByAgeGroupQuery, TeamsByAgeGroupQueryVariables>) {
        return Apollo.useQuery<TeamsByAgeGroupQuery, TeamsByAgeGroupQueryVariables>(TeamsByAgeGroupDocument, baseOptions);
      }
export function useTeamsByAgeGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamsByAgeGroupQuery, TeamsByAgeGroupQueryVariables>) {
          return Apollo.useLazyQuery<TeamsByAgeGroupQuery, TeamsByAgeGroupQueryVariables>(TeamsByAgeGroupDocument, baseOptions);
        }
export type TeamsByAgeGroupQueryHookResult = ReturnType<typeof useTeamsByAgeGroupQuery>;
export type TeamsByAgeGroupLazyQueryHookResult = ReturnType<typeof useTeamsByAgeGroupLazyQuery>;
export type TeamsByAgeGroupQueryResult = Apollo.QueryResult<TeamsByAgeGroupQuery, TeamsByAgeGroupQueryVariables>;
export const VerifyPasswordResetTokenDocument = gql`
    query VerifyPasswordResetToken($token: String!) {
  verifyPasswordResetTokenIsValid(token: $token)
}
    `;

/**
 * __useVerifyPasswordResetTokenQuery__
 *
 * To run a query within a React component, call `useVerifyPasswordResetTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifyPasswordResetTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifyPasswordResetTokenQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useVerifyPasswordResetTokenQuery(baseOptions: Apollo.QueryHookOptions<VerifyPasswordResetTokenQuery, VerifyPasswordResetTokenQueryVariables>) {
        return Apollo.useQuery<VerifyPasswordResetTokenQuery, VerifyPasswordResetTokenQueryVariables>(VerifyPasswordResetTokenDocument, baseOptions);
      }
export function useVerifyPasswordResetTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VerifyPasswordResetTokenQuery, VerifyPasswordResetTokenQueryVariables>) {
          return Apollo.useLazyQuery<VerifyPasswordResetTokenQuery, VerifyPasswordResetTokenQueryVariables>(VerifyPasswordResetTokenDocument, baseOptions);
        }
export type VerifyPasswordResetTokenQueryHookResult = ReturnType<typeof useVerifyPasswordResetTokenQuery>;
export type VerifyPasswordResetTokenLazyQueryHookResult = ReturnType<typeof useVerifyPasswordResetTokenLazyQuery>;
export type VerifyPasswordResetTokenQueryResult = Apollo.QueryResult<VerifyPasswordResetTokenQuery, VerifyPasswordResetTokenQueryVariables>;
export const VerifySessionDocument = gql`
    query VerifySession {
  verifySession
}
    `;

/**
 * __useVerifySessionQuery__
 *
 * To run a query within a React component, call `useVerifySessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useVerifySessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifySessionQuery({
 *   variables: {
 *   },
 * });
 */
export function useVerifySessionQuery(baseOptions?: Apollo.QueryHookOptions<VerifySessionQuery, VerifySessionQueryVariables>) {
        return Apollo.useQuery<VerifySessionQuery, VerifySessionQueryVariables>(VerifySessionDocument, baseOptions);
      }
export function useVerifySessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VerifySessionQuery, VerifySessionQueryVariables>) {
          return Apollo.useLazyQuery<VerifySessionQuery, VerifySessionQueryVariables>(VerifySessionDocument, baseOptions);
        }
export type VerifySessionQueryHookResult = ReturnType<typeof useVerifySessionQuery>;
export type VerifySessionLazyQueryHookResult = ReturnType<typeof useVerifySessionLazyQuery>;
export type VerifySessionQueryResult = Apollo.QueryResult<VerifySessionQuery, VerifySessionQueryVariables>;